export interface Hymn {
    title: string;
    text: string[][][];
    clef: "c5" | "c7" | "f5";
    tune: string[][];
    amen: [string, string];
    tone: string;
}

export const HYMNS: { [id: string]: Hymn } = {
    "to-thee-before-the-close-of-day": {
        // compline
        title: "Te lucis ante terminum",
        text: [
            [
                ["TO"],
                ["thee"],
                ["be", "fore"],
                ["the"],
                ["close"],
                ["of"],
                ["day,"],
            ],
            [
                ["Cre", "a", "tor"],
                ["of"],
                ["the"],
                ["world,"],
                ["we"],
                ["pray,"],
            ],
            [
                ["that"],
                ["with"],
                ["thy"],
                ["won", "ted"],
                ["fa", "vour"],
                ["thou"],
            ],
            [
                ["wouldst"],
                ["be"],
                ["our"],
                ["guard"],
                ["and"],
                ["kee", "per"],
                ["now."],
            ],
            [
                ["From"],
                ["all"],
                ["ill"],
                ["dreams"],
                ["de", "fend"],
                ["our"],
                ["eyes,"],
            ],
            [
                ["from"],
                ["night", "ly"],
                ["fears"],
                ["and"],
                ["fan", "ta", "sies"],
            ],
            [
                ["tread"],
                ["un", "der"],
                ["foot"],
                ["our"],
                ["ghost", "ly"],
                ["foe,"],
            ],
            [
                ["that"],
                ["no"],
                ["pol", "lu", "tion"],
                ["we"],
                ["may"],
                ["know."],
            ],
            [
                ["O"],
                ["Fa", "ther,"],
                ["that"],
                ["we"],
                ["ask"],
                ["be"],
                ["done,"],
            ],
            [
                ["through"],
                ["Je", "sus"],
                ["Christ,"],
                ["thine"],
                ["on", "ly"],
                ["Son;"],
            ],
            [
                ["who,"],
                ["with"],
                ["the"],
                ["Ho", "ly"],
                ["Ghost"],
                ["and"],
                ["thee,"],
            ],
            [
                ["doth"],
                ["live"],
                ["and"],
                ["reign"],
                ["e", "ter", "nal", "ly."],
            ],
        ],
        tune: [
            ["5", "7", "7", "7", "7", "8", "7", "6"],
            ["5", "5", "5", "5", "6", "6", "5", "4"],
            ["6", "6", "5", "4", "2", "4", "5", "5"],
            ["7", "7", "7", "7", "5", "6", "5", "4"],
        ],
        amen: ["45", "434"],
        clef: "c7",
        tone: "8",
    },
    "this-day-the-first-of-days-was-made": {
        // sunday
        title: "Primo dierum omnium",
        text: [
            [
                ["THIS"],
                ["day"],
                ["the"],
                ["first"],
                ["of"],
                ["days"],
                ["was"],
                ["made,"],
            ],
            [
                ["When"],
                ["God"],
                ["in"],
                ["light"],
                ["the"],
                ["world"],
                ["ar", "rayed;"],
            ],
            [
                ["Or"],
                ["when"],
                ["his"],
                ["Word"],
                ["a", "rose"],
                ["a", "gain,"],
            ],
            [
                ["And,"],
                ["con", "q'ring"],
                ["death,"],
                ["gave"],
                ["life"],
                ["to"],
                ["men."],
            ],
            [
                ["Slum", "ber"],
                ["and"],
                ["sloth"],
                ["drive"],
                ["far"],
                ["a", "way;"],
            ],
            [
                ["Ear", "lier"],
                ["a", "rise"],
                ["to"],
                ["greet"],
                ["the"],
                ["day;"],
            ],
            [
                ["And"],
                ["ere"],
                ["its"],
                ["dawn"],
                ["in"],
                ["heav'n"],
                ["un", "fold"],
            ],
            [
                ["The"],
                ["heart's"],
                ["de", "sire"],
                ["to"],
                ["God"],
                ["be"],
                ["told."],
            ],
            [
                ["Un", "to"],
                ["our"],
                ["prayer"],
                ["that"],
                ["he"],
                ["at", "tend,"],
            ],
            [["His"], ["all-", "cre", "a", "ting"], ["pow'r"], ["ex", "tend,"]],
            [
                ["And"],
                ["still"],
                ["re", "new"],
                ["us,"],
                ["lest"],
                ["we"],
                ["miss,"],
            ],
            [
                ["Through"],
                ["earth", "ly"],
                ["stain"],
                ["our"],
                ["heav'n", "ly"],
                ["bliss."],
            ],
            [
                ["That"],
                ["us,"],
                ["who"],
                ["here"],
                ["this"],
                ["day"],
                ["re", "pair"],
            ],
            [
                ["To"],
                ["keep"],
                ["the-", "Apos", "tles'"],
                ["time"],
                ["of"],
                ["pray'r,"],
            ],
            [
                ["And"],
                ["hymn"],
                ["the"],
                ["qui", "et"],
                ["hours"],
                ["of"],
                ["morn,"],
            ],
            [
                ["With"],
                ["bless-", "ed"],
                ["gifts"],
                ["he"],
                ["may"],
                ["a", "dorn."],
            ],
            [
                ["For"],
                ["this,"],
                ["Re", "dee", "mer,"],
                ["thee"],
                ["we"],
                ["pray,"],
            ],
            [
                ["That"],
                ["thou"],
                ["wilt"],
                ["wash"],
                ["our"],
                ["sins"],
                ["a", "way,"],
            ],
            [
                ["And"],
                ["of"],
                ["thy"],
                ["lo", "ving-", "kind", "ness"],
                ["grant"],
            ],
            [
                ["What", "e'er"],
                ["of"],
                ["good"],
                ["our"],
                ["spi", "rits"],
                ["want."],
            ],
            [
                ["That"],
                ["ex", "iles"],
                ["here"],
                ["a", "while"],
                ["in"],
                ["flesh"],
            ],
            [
                ["Some"],
                ["ear", "nest"],
                ["may"],
                ["our"],
                ["souls"],
                ["re", "fresh"],
            ],
            [
                ["Of"],
                ["that"],
                ["pure"],
                ["life"],
                ["for"],
                ["which"],
                ["we"],
                ["long,"],
            ],
            [
                ["Some"],
                ["fore", "taste"],
                ["of"],
                ["the"],
                ["heav'n", "ly"],
                ["song."],
            ],
            [
                ["O"],
                ["Fa", "ther,"],
                ["that"],
                ["we"],
                ["ask"],
                ["be"],
                ["done,"],
            ],
            [
                ["Through"],
                ["Je", "sus"],
                ["Christ,"],
                ["thine"],
                ["on", "ly"],
                ["Son;"],
            ],
            [
                ["Who"],
                ["with"],
                ["the"],
                ["Ho", "ly"],
                ["Ghost"],
                ["and"],
                ["thee,"],
            ],
            [
                ["Doth"],
                ["live"],
                ["and"],
                ["reign"],
                ["e", "ter", "nal", "ly."],
            ],
        ],
        tune: [
            ["1", "2", "3", "4", "24", "3", "2", "3"],
            ["1", "2", "3", "4", "24", "3", "2", "121"],
            ["2", "0", "2", "45", "56", "5", "4", "5"],
            ["5", "5", "5", "4", "3", "4", "3", "2"],
        ],
        amen: ["23", "212"],
        clef: "c7",
        tone: "4",
    },
    "o-splendour-of-gods-glory-bright": {
        // monday
        title: "Splendor paternae gloriae",
        text: [
            [
                ["O"],
                ["SPLEN", "DOUR"],
                ["of"],
                ["God's"],
                ["glo", "ry"],
                ["bright,"],
            ],
            [
                ["O"],
                ["thou"],
                ["that"],
                ["bring", "est"],
                ["light"],
                ["from"],
                ["light,"],
            ],
            [
                ["O"],
                ["Light"],
                ["of"],
                ["light,"],
                ["light's"],
                ["liv", "ing"],
                ["spring,"],
            ],
            [["O"], ["Day,"], ["all"], ["days"], ["il", "lu", "min", "ing."]],
            [
                ["O"],
                ["thou"],
                ["true"],
                ["Sun,"],
                ["on"],
                ["us"],
                ["thy"],
                ["glance"],
            ],
            [["Let"], ["fall"], ["in"], ["roy", "al"], ["ra", "di", "ance,"]],
            [["The"], ["Spi", "rit's"], ["sanc", "ti", "fy", "ing"], ["beam,"]],
            [
                ["Up", "on"],
                ["our"],
                ["earth", "ly"],
                ["sen", "ses"],
                ["stream."],
            ],
            [
                ["The"],
                ["Fa", "ther"],
                ["too,"],
                ["our"],
                ["pray'rs"],
                ["im", "plore,"],
            ],
            [["Fa", "ther"], ["of"], ["glo", "ry"], ["e", "ver", "more;"]],
            [
                ["The"],
                ["Fa", "ther"],
                ["of"],
                ["all"],
                ["grace"],
                ["and"],
                ["might,"],
            ],
            [
                ["To"],
                ["ban", "ish"],
                ["sin"],
                ["from"],
                ["our"],
                ["de", "light:"],
            ],
            [
                ["To"],
                ["guide"],
                ["what", "e'er"],
                ["we"],
                ["no", "bly"],
                ["do,"],
            ],
            [
                ["With"],
                ["love"],
                ["all"],
                ["en", "vy"],
                ["to"],
                ["sub", "due,"],
            ],
            [
                ["To"],
                ["make"],
                ["ill-", "for", "tune"],
                ["turn"],
                ["to"],
                ["fair,"],
            ],
            [
                ["And"],
                ["give"],
                ["us"],
                ["grace"],
                ["our"],
                ["wrongs"],
                ["to"],
                ["bear."],
            ],
            [
                ["Our"],
                ["mind"],
                ["be"],
                ["in"],
                ["his"],
                ["kee", "ping"],
                ["placed,"],
            ],
            [
                ["Our"],
                ["bo", "dy"],
                ["true"],
                ["to"],
                ["him"],
                ["and"],
                ["chaste,"],
            ],
            [
                ["Where"],
                ["on", "ly"],
                ["faith"],
                ["here"],
                ["fire"],
                ["shall"],
                ["feed,"],
            ],
            [
                ["To"],
                ["burn"],
                ["the"],
                ["tares"],
                ["of"],
                ["Sa", "tan's"],
                ["seed."],
            ],
            [
                ["And"],
                ["Christ"],
                ["to"],
                ["us"],
                ["for"],
                ["food"],
                ["shall"],
                ["be,"],
            ],
            [
                ["From"],
                ["him"],
                ["our"],
                ["drink"],
                ["that"],
                ["well", "eth"],
                ["free,"],
            ],
            [
                ["The"],
                ["Spi", "rit's"],
                ["wine,"],
                ["that"],
                ["mak", "eth"],
                ["whole,"],
            ],
            [
                ["And,"],
                ["mock", "ing"],
                ["not,"],
                ["ex", "alts"],
                ["the"],
                ["soul."],
            ],
            [
                ["Re", "joic", "ing"],
                ["may"],
                ["this"],
                ["day"],
                ["go"],
                ["hence."],
            ],
            [
                ["Like"],
                ["vir", "gin"],
                ["dawn"],
                ["our"],
                ["in", "no", "cence,"],
            ],
            [
                ["Like"],
                ["fie", "ry"],
                ["noon"],
                ["our"],
                ["faith"],
                ["ap", "pear,"],
            ],
            [
                ["Nor"],
                ["know"],
                ["the"],
                ["gloom"],
                ["of"],
                ["twi", "light"],
                ["drear."],
            ],
            [
                ["Morn"],
                ["in"],
                ["her"],
                ["ro", "sy"],
                ["car"],
                ["is"],
                ["borne;"],
            ],
            [
                ["Let"],
                ["him"],
                ["come"],
                ["forth"],
                ["our"],
                ["per", "fect"],
                ["morn,"],
            ],
            [
                ["The"],
                ["Word"],
                ["in"],
                ["God"],
                ["the"],
                ["Fa", "ther"],
                ["one,"],
            ],
            [
                ["The"],
                ["Fa", "ther"],
                ["per", "fect"],
                ["in"],
                ["the"],
                ["Son."],
            ],
            [
                ["All"],
                ["laud"],
                ["to"],
                ["God"],
                ["the"],
                ["Fa", "ther"],
                ["be,"],
            ],
            [
                ["All"],
                ["praise,"],
                ["e", "ter", "nal"],
                ["Son,"],
                ["to"],
                ["thee;"],
            ],
            [["All"], ["glo", "ry,"], ["as"], ["is"], ["e", "ver"], ["meet,"]],
            [["To"], ["God"], ["the"], ["ho", "ly"], ["Pa", "ra", "clete."]],
        ],
        tune: [
            ["3", "3", "4", "5", "6b", "5", "4", "5"],
            ["5", "4", "7", "7", "4", "5", "6b", "54"],
            ["5", "5", "4", "5", "4", "3", "2", "3"],
            ["4", "5", "4", "3", "2", "34", "2", "1"],
        ],
        amen: ["12", "101"],
        clef: "c7",
        tone: "1",
    },
    "the-wing-ed-herald-of-the-day": {
        // tuesday
        title: "Ales diei nuntius",
        text: [
            [
                ["THE"],
                ["wing-", "ed"],
                ["he", "rald"],
                ["of"],
                ["the"],
                ["day"],
            ],
            [
                ["Pro", "claims"],
                ["the"],
                ["morn's"],
                ["ap", "proach", "ing"],
                ["ray:"],
            ],
            [
                ["And"],
                ["Christ"],
                ["the"],
                ["Lord"],
                ["our"],
                ["soul"],
                ["ex", "cites,"],
            ],
            [
                ["And"],
                ["so"],
                ["to"],
                ["end", "less"],
                ["life"],
                ["in", "vites."],
            ],
            [
                ["Take"],
                ["up"],
                ["thy"],
                ["bed,"],
                ["to"],
                ["each"],
                ["he"],
                ["cries,"],
            ],
            [
                ["Who"],
                ["sick"],
                ["or"],
                ["wrapt"],
                ["in"],
                ["slum", "ber"],
                ["lies;"],
            ],
            [
                ["And"],
                ["chaste"],
                ["and"],
                ["just"],
                ["and"],
                ["so", "ber"],
                ["stand,"],
            ],
            [
                ["And"],
                ["watch:"],
                ["my"],
                ["com", "ing"],
                ["is"],
                ["at"],
                ["hand."],
            ],
            [
                ["With"],
                ["ear", "nest"],
                ["cry,"],
                ["with"],
                ["tear", "ful"],
                ["care,"],
            ],
            [
                ["Call"],
                ["we"],
                ["the"],
                ["Lord"],
                ["to"],
                ["hear"],
                ["our"],
                ["pray'r;"],
            ],
            [
                ["While"],
                ["supp", "li", "ca", "tion,"],
                ["pure"],
                ["and"],
                ["deep,"],
            ],
            [
                ["For", "bids"],
                ["each"],
                ["chast", "en'd"],
                ["heart"],
                ["to"],
                ["sleep."],
            ],
            [
                ["Do"],
                ["thou,"],
                ["O"],
                ["Christ,"],
                ["our"],
                ["slum", "bers"],
                ["wake;"],
            ],
            [
                ["Do"],
                ["thou"],
                ["the"],
                ["chains"],
                ["of"],
                ["dark", "ness"],
                ["break;"],
            ],
            [
                ["Purge"],
                ["thou"],
                ["our"],
                ["for", "mer"],
                ["sins"],
                ["a", "way,"],
            ],
            [
                ["And"],
                ["in"],
                ["our"],
                ["souls"],
                ["new"],
                ["light"],
                ["dis", "play."],
            ],
            [
                ["All"],
                ["laud"],
                ["to"],
                ["God"],
                ["the"],
                ["Fa", "ther"],
                ["be,"],
            ],
            [
                ["All"],
                ["praise,"],
                ["e", "ter", "nal"],
                ["Son,"],
                ["to"],
                ["thee;"],
            ],
            [["All"], ["glo", "ry,"], ["as"], ["is"], ["e", "ver"], ["meet,"]],
            [["To"], ["God"], ["the"], ["ho", "ly"], ["Pa", "ra", "clete."]],
        ],
        tune: [
            ["3", "3", "4", "5", "6b", "5", "4", "5"],
            ["5", "4", "7", "7", "4", "5", "6b", "54"],
            ["5", "5", "4", "5", "4", "3", "2", "3"],
            ["4", "5", "4", "3", "2", "34", "2", "1"],
        ],
        amen: ["12", "101"],
        clef: "c7",
        tone: "1",
    },
    "ye-clouds-and-darkness-hosts-of-night": {
        // wednesday
        title: "Nox et tenebrae et nubila",
        text: [
            [
                ["YE"],
                ["clouds"],
                ["and"],
                ["dark", "ness,"],
                ["hosts"],
                ["of"],
                ["night,"],
            ],
            [
                ["That"],
                ["breed"],
                ["con", "fu", "sion"],
                ["and"],
                ["af", "fright,"],
            ],
            [
                ["Be", "gone!"],
                ["O'er", "head"],
                ["the"],
                ["dawn"],
                ["shines"],
                ["clear,"],
            ],
            [
                ["The"],
                ["light"],
                ["breaks"],
                ["in"],
                ["and"],
                ["Christ"],
                ["is"],
                ["here."],
            ],
            [
                ["Earth's"],
                ["gloom"],
                ["flees"],
                ["bro", "ken"],
                ["and"],
                ["dis", "persed,"],
            ],
            [
                ["By"],
                ["the"],
                ["sun's"],
                ["pier", "cing"],
                ["shafts"],
                ["co", "erced:"],
            ],
            [
                ["The"],
                ["day-", "star's"],
                ["eyes"],
                ["rain"],
                ["in", "fluence"],
                ["bright,"],
            ],
            [
                ["And"],
                ["co", "lours"],
                ["glim", "mer"],
                ["back"],
                ["to"],
                ["sight."],
            ],
            [
                ["Thee,"],
                ["Christ,"],
                ["a", "lone"],
                ["we"],
                ["know;"],
                ["to"],
                ["thee"],
            ],
            [["We"], ["bend"], ["in"], ["pure"], ["sim", "pli", "ci", "ty;"]],
            [
                ["Our"],
                ["songs"],
                ["with"],
                ["tears"],
                ["to"],
                ["thee"],
                ["a", "rise;"],
            ],
            [
                ["Prove"],
                ["thou"],
                ["our"],
                ["hearts"],
                ["with"],
                ["thy"],
                ["clear"],
                ["eyes."],
            ],
            [
                ["Though"],
                ["we"],
                ["be"],
                ["stained"],
                ["with"],
                ["blots"],
                ["with", "in,"],
            ],
            [
                ["Thy"],
                ["quick'", "ning"],
                ["rays"],
                ["shall"],
                ["purge"],
                ["our"],
                ["sin;"],
            ],
            [
                ["Light"],
                ["of"],
                ["the"],
                ["Morn", "ing"],
                ["Star,"],
                ["thy"],
                ["grace,"],
            ],
            [
                ["Shed"],
                ["on"],
                ["us"],
                ["from"],
                ["thy"],
                ["cloud", "less"],
                ["face."],
            ],
            [
                ["All"],
                ["laud"],
                ["to"],
                ["God"],
                ["the"],
                ["Fa", "ther"],
                ["be,"],
            ],
            [
                ["All"],
                ["praise,"],
                ["e", "ter", "nal"],
                ["Son,"],
                ["to"],
                ["thee;"],
            ],
            [["All"], ["glo", "ry,"], ["as"], ["is"], ["e", "ver"], ["meet,"]],
            [["To"], ["God"], ["the"], ["ho", "ly"], ["Pa", "ra", "clete."]],
        ],
        tune: [
            ["3", "3", "4", "5", "6b", "5", "4", "5"],
            ["5", "4", "7", "7", "4", "5", "6b", "54"],
            ["5", "5", "4", "5", "4", "3", "2", "3"],
            ["4", "5", "4", "3", "2", "34", "2", "1"],
        ],
        amen: ["12", "101"],
        clef: "c7",
        tone: "1",
    },
    "lo-golden-light-rekindles-day": {
        // thursday
        title: "Lux ecce surgit aurea",
        text: [
            [
                ["LO!"],
                ["Gold", "en"],
                ["light"],
                ["re", "kin", "dles"],
                ["day:"],
            ],
            [
                ["Let"],
                ["pal", "ing"],
                ["dark", "ness"],
                ["steal"],
                ["a", "way,"],
            ],
            [
                ["Which"],
                ["all"],
                ["too"],
                ["long"],
                ["o'er", "whelm'd"],
                ["our"],
                ["gaze,"],
            ],
            [
                ["And"],
                ["led"],
                ["our"],
                ["steps"],
                ["by"],
                ["wind", "ing"],
                ["ways."],
            ],
            [
                ["We"],
                ["pray"],
                ["thee,"],
                ["ris", "ing"],
                ["Light"],
                ["se", "rene,"],
            ],
            [
                ["Ev'n"],
                ["as"],
                ["thy", "self"],
                ["our"],
                ["hearts"],
                ["make"],
                ["clean;"],
            ],
            [
                ["Let"],
                ["no"],
                ["de", "ceit"],
                ["our"],
                ["lips"],
                ["de", "file,"],
            ],
            [
                ["Nor"],
                ["let"],
                ["our"],
                ["souls"],
                ["be"],
                ["vex'd"],
                ["by"],
                ["guile."],
            ],
            [
                ["O"],
                ["keep"],
                ["us,"],
                ["as"],
                ["the"],
                ["hours"],
                ["pro", "ceed,"],
            ],
            [
                ["From"],
                ["ly", "ing"],
                ["word"],
                ["and"],
                ["e", "vil"],
                ["deed;"],
            ],
            [
                ["Our"],
                ["rov", "ing"],
                ["eyes"],
                ["from"],
                ["sin"],
                ["set"],
                ["free,"],
            ],
            [["Our"], ["bo", "dy"], ["from"], ["im", "pu", "ri", "ty."]],
            [
                ["For"],
                ["thou"],
                ["dost"],
                ["from"],
                ["a", "bove"],
                ["sur", "vey"],
            ],
            [
                ["The"],
                ["con", "verse"],
                ["of"],
                ["each"],
                ["fleet", "ing"],
                ["day;"],
            ],
            [
                ["Thou"],
                ["dost"],
                ["fore", "see"],
                ["from"],
                ["morn", "ing"],
                ["light"],
            ],
            [
                ["Our"],
                ["ev'", "ry"],
                ["deed,"],
                ["un", "til"],
                ["the"],
                ["night."],
            ],
            [
                ["All"],
                ["laud"],
                ["to"],
                ["God"],
                ["the"],
                ["Fa", "ther"],
                ["be,"],
            ],
            [
                ["All"],
                ["praise,"],
                ["e", "ter", "nal"],
                ["Son,"],
                ["to"],
                ["thee;"],
            ],
            [["All"], ["glo", "ry,"], ["as"], ["is"], ["e", "ver"], ["meet,"]],
            [["To"], ["God"], ["the"], ["ho", "ly"], ["Pa", "ra", "clete."]],
        ],
        tune: [
            ["3", "3", "4", "5", "6b", "5", "4", "5"],
            ["5", "4", "7", "7", "4", "5", "6b", "54"],
            ["5", "5", "4", "5", "4", "3", "2", "3"],
            ["4", "5", "4", "3", "2", "34", "2", "1"],
        ],
        amen: ["12", "101"],
        clef: "c7",
        tone: "1",
    },
    "eternal-glory-of-the-sky": {
        // friday
        title: "Aeterna coeli gloria",
        text: [
            [["E", "TER", "NAL"], ["Glo", "ry"], ["of"], ["the"], ["sky,"]],
            [["Blest"], ["hope"], ["of"], ["frail"], ["hu", "ma", "ni", "ty,"]],
            [
                ["The"],
                ["Fa", "ther's"],
                ["sole-", "be", "got", "ten"],
                ["One,"],
            ],
            [
                ["Yet"],
                ["born"],
                ["a"],
                ["spot", "less"],
                ["Vir", "gin's"],
                ["Son!"],
            ],
            [
                ["Up", "lift"],
                ["us"],
                ["with"],
                ["thine"],
                ["arm"],
                ["of"],
                ["might,"],
            ],
            [
                ["And"],
                ["let"],
                ["our"],
                ["hearts"],
                ["rise"],
                ["pure"],
                ["and"],
                ["bright,"],
            ],
            [
                ["And,"],
                ["ar", "dent"],
                ["in"],
                ["God's"],
                ["prais", "es"],
                ["pay"],
            ],
            [
                ["The"],
                ["thanks"],
                ["we"],
                ["owe"],
                ["him"],
                ["ev'", "ry"],
                ["day."],
            ],
            [
                ["The"],
                ["day-", "star's"],
                ["rays"],
                ["are"],
                ["glitt", "'ring"],
                ["clear,"],
            ],
            [
                ["And"],
                ["tell"],
                ["that"],
                ["day"],
                ["it", "self"],
                ["is"],
                ["near:"],
            ],
            [
                ["The"],
                ["sha", "dows"],
                ["of"],
                ["the"],
                ["night"],
                ["de", "part;"],
            ],
            [
                ["Thou,"],
                ["ho", "ly"],
                ["Light,"],
                ["il", "lume"],
                ["the"],
                ["heart!"],
            ],
            [["With", "in"], ["our"], ["sen", "ses"], ["e", "ver"], ["dwell,"]],
            [
                ["And"],
                ["world", "ly"],
                ["dark", "ness"],
                ["thence"],
                ["ex", "pel;"],
            ],
            [
                ["Long"],
                ["as"],
                ["the"],
                ["days"],
                ["of"],
                ["life"],
                ["en", "dure,"],
            ],
            [
                ["Pre", "serve"],
                ["our"],
                ["souls"],
                ["de", "vout"],
                ["and"],
                ["pure."],
            ],
            [
                ["The"],
                ["faith"],
                ["that"],
                ["first"],
                ["must"],
                ["be"],
                ["pos", "sest,"],
            ],
            [
                ["Root"],
                ["deep"],
                ["with", "in"],
                ["our"],
                ["in", "most"],
                ["breast;"],
            ],
            [
                ["And"],
                ["joy", "ous"],
                ["hope"],
                ["in"],
                ["se", "cond"],
                ["place,"],
            ],
            [
                ["Then"],
                ["cha", "ri", "ty,"],
                ["thy"],
                ["great", "est"],
                ["grace."],
            ],
            [
                ["All"],
                ["laud"],
                ["to"],
                ["God"],
                ["the"],
                ["Fa", "ther"],
                ["be,"],
            ],
            [
                ["All"],
                ["praise,"],
                ["e", "ter", "nal"],
                ["Son,"],
                ["to"],
                ["thee;"],
            ],
            [["All"], ["glo", "ry,"], ["as"], ["is"], ["e", "ver"], ["meet,"]],
            [["To"], ["God"], ["the"], ["ho", "ly"], ["Pa", "ra", "clete."]],
        ],
        tune: [
            ["3", "3", "4", "5", "6b", "5", "4", "5"],
            ["5", "4", "7", "7", "4", "5", "6b", "54"],
            ["5", "5", "4", "5", "4", "3", "2", "3"],
            ["4", "5", "4", "3", "2", "34", "2", "1"],
        ],
        amen: ["12", "101"],
        clef: "c7",
        tone: "1",
    },
    "the-dawn-is-sprinkling-in-the-east": {
        // saturday
        title: "Aurora jam spargit polum",
        text: [
            [
                ["DAWN"],
                ["sprin", "kles"],
                ["all"],
                ["the"],
                ["East"],
                ["with"],
                ["light:"],
            ],
            [
                ["Day"],
                ["o’er"],
                ["the"],
                ["earth"],
                ["is"],
                ["gli", "ding"],
                ["bright:"],
            ],
            [
                ["Morn’s"],
                ["glitt’", "ring"],
                ["rays"],
                ["their"],
                ["course"],
                ["be", "gin;"],
            ],
            [
                ["Fare", "well"],
                ["to"],
                ["dark", "ness"],
                ["and"],
                ["to"],
                ["sin."],
            ],
            [
                ["Each"],
                ["phan", "tom"],
                ["of"],
                ["the"],
                ["night"],
                ["de", "part,"],
            ],
            [
                ["Each"],
                ["thought"],
                ["of"],
                ["guilt"],
                ["for", "sake"],
                ["the"],
                ["heart:"],
            ],
            [
                ["Let"],
                ["ev’", "ry"],
                ["ill"],
                ["that"],
                ["dark", "ness"],
                ["brought"],
            ],
            [
                ["Be", "neath"],
                ["its"],
                ["shade,"],
                ["now"],
                ["come"],
                ["to"],
                ["nought."],
            ],
            [
                ["So"],
                ["that"],
                ["last"],
                ["morn", "ing,"],
                ["dread"],
                ["and"],
                ["great,"],
            ],
            [
                ["Which"],
                ["we"],
                ["with"],
                ["tremb", "ling"],
                ["hope"],
                ["a", "wait,"],
            ],
            [
                ["With"],
                ["bless", "ed"],
                ["light"],
                ["for"],
                ["us"],
                ["shall"],
                ["glow,"],
            ],
            [
                ["Who"],
                ["chant"],
                ["the"],
                ["song"],
                ["we"],
                ["sang"],
                ["be", "low,—"],
            ],
            [
                ["All"],
                ["laud"],
                ["to"],
                ["God"],
                ["the"],
                ["Fa", "ther"],
                ["be,"],
            ],
            [
                ["All"],
                ["praise,"],
                ["e", "ter", "nal"],
                ["Son,"],
                ["to"],
                ["thee;"],
            ],
            [["All"], ["glo", "ry,"], ["as"], ["is"], ["e", "ver"], ["meet,"]],
            [["To"], ["God"], ["the"], ["ho", "ly"], ["Pa", "ra", "clete."]],
        ],
        tune: [
            ["3", "3", "4", "5", "6b", "5", "4", "5"],
            ["5", "4", "7", "7", "4", "5", "6b", "54"],
            ["5", "5", "4", "5", "4", "3", "2", "3"],
            ["4", "5", "4", "3", "2", "34", "2", "1"],
        ],
        amen: ["12", "101"],
        clef: "c7",
        tone: "1",
    },
    "the-fast-as-taught-by-holy-lore": {
        // lent, evening until lent 3
        title: "Ex more docti mystico",
        text: [
            [
                ["THE"],
                ["fast"],
                ["as"],
                ["taught"],
                ["by"],
                ["ho", "ly"],
                ["lore,"],
            ],
            [
                ["We"],
                ["keep"],
                ["in"],
                ["so", "lemn"],
                ["course"],
                ["once"],
                ["more:"],
            ],
            [
                ["The"],
                ["fast"],
                ["to"],
                ["all"],
                ["men"],
                ["known,"],
                ["and"],
                ["bound"],
            ],
            [
                ["In"],
                ["for", "ty"],
                ["days"],
                ["of"],
                ["year", "ly"],
                ["round."],
            ],
            [
                ["The"],
                ["law"],
                ["and"],
                ["seers"],
                ["that"],
                ["were"],
                ["of"],
                ["old"],
            ],
            [
                ["In"],
                ["di", "verse"],
                ["ways"],
                ["this"],
                ["Lent"],
                ["fore", "told,"],
            ],
            [
                ["Which"],
                ["Christ,"],
                ["all"],
                ["sea", "sons'"],
                ["King"],
                ["and"],
                ["guide,"],
            ],
            [["In"], ["af", "ter"], ["a", "ges"], ["sanc", "ti", "fied."]],
            [
                ["More"],
                ["spar", "ing"],
                ["there", "fore"],
                ["let"],
                ["us"],
                ["make"],
            ],
            [
                ["The"],
                ["words"],
                ["we"],
                ["speak,"],
                ["the"],
                ["food"],
                ["we"],
                ["take,"],
            ],
            [
                ["Our"],
                ["sleep"],
                ["and"],
                ["mirth;"],
                ["and"],
                ["clo", "ser"],
                ["barred"],
            ],
            [
                ["Be"],
                ["ev", "ery"],
                ["sense"],
                ["in"],
                ["ho", "ly"],
                ["guard."],
            ],
            [
                ["In"],
                ["prayer"],
                ["to", "ge", "ther"],
                ["let"],
                ["us"],
                ["fall,"],
            ],
            [
                ["And"],
                ["cry"],
                ["for"],
                ["mer", "cy,"],
                ["one"],
                ["and"],
                ["all,"],
            ],
            [
                ["And"],
                ["weep"],
                ["be", "fore"],
                ["the"],
                ["Judg", "e's"],
                ["feet,"],
            ],
            [
                ["And"],
                ["his"],
                ["a", "veng", "ing"],
                ["wrath"],
                ["en", "treat."],
            ],
            [
                ["Thy"],
                ["grace"],
                ["have"],
                ["we"],
                ["of", "fen", "ded"],
                ["sore,"],
            ],
            [
                ["By"],
                ["sins,"],
                ["O"],
                ["God,"],
                ["which"],
                ["we"],
                ["de", "plore;"],
            ],
            [
                ["But"],
                ["pour"],
                ["up", "on"],
                ["us"],
                ["from"],
                ["on"],
                ["high,"],
            ],
            [
                ["O"],
                ["pard", "'ning"],
                ["One,"],
                ["thy"],
                ["clem", "en", "cy."],
            ],
            [
                ["Re", "mem", "ber"],
                ["thou,"],
                ["though"],
                ["frail"],
                ["we"],
                ["be,"],
            ],
            [
                ["That"],
                ["yet"],
                ["thine"],
                ["han", "di", "work"],
                ["are"],
                ["we;"],
            ],
            [
                ["Nor"],
                ["let"],
                ["the"],
                ["ho", "nour"],
                ["of"],
                ["thy"],
                ["name"],
            ],
            [["Be"], ["by"], ["a", "no", "ther"], ["put"], ["to"], ["shame."]],
            [
                ["For", "give"],
                ["the"],
                ["sin"],
                ["that"],
                ["we"],
                ["have"],
                ["wrought;"],
            ],
            [
                ["In", "crease"],
                ["the"],
                ["good"],
                ["that"],
                ["we"],
                ["have"],
                ["sought;"],
            ],
            [
                ["That"],
                ["we"],
                ["at"],
                ["length,"],
                ["our"],
                ["wan", "d'rings"],
                ["o'er,"],
            ],
            [
                ["May"],
                ["please"],
                ["thee"],
                ["here"],
                ["and"],
                ["e", "ver", "more."],
            ],
            [["We"], ["pray"], ["thee,"], ["Ho", "ly"], ["Tri", "ni", "ty,"]],
            [["One"], ["God,"], ["un", "chang", "ing"], ["U", "ni", "ty,"]],
            [
                ["That"],
                ["we"],
                ["from"],
                ["this"],
                ["our"],
                ["ab", "sti", "nence"],
            ],
            [
                ["May"],
                ["reap"],
                ["the"],
                ["fruits"],
                ["of"],
                ["pe", "ni", "tence."],
            ],
        ],
        tune: [
            ["4", "6", "67", "7", "65", "6", "6", "7"],
            ["6", "4", "5", "6", "54", "3", "24", "4"],
            ["4", "6", "67", "76", "43", "5", "43", "34"],
            ["2", "54", "56", "54", "2", "45", "3", "3"],
        ],
        amen: ["34", "323"],
        clef: "f5",
        tone: "2",
    },
    "o-kind-creator-bow-thine-ear": {
        // lent, morning until lent 3
        title: "Audi, benigne Conditor",
        text: [
            [
                ["O"],
                ["KIND"],
                ["Cre", "a", "tor,"],
                ["bow"],
                ["thine"],
                ["ear"],
            ],
            [
                ["To"],
                ["mark"],
                ["the"],
                ["cry,"],
                ["to"],
                ["know"],
                ["the"],
                ["tear"],
            ],
            [
                ["Be", "fore"],
                ["thy"],
                ["throne"],
                ["of"],
                ["mer", "cy"],
                ["spent"],
            ],
            [
                ["In"],
                ["this"],
                ["thy"],
                ["ho", "ly"],
                ["fast"],
                ["of"],
                ["Lent."],
            ],
            [
                ["Our"],
                ["hearts"],
                ["are"],
                ["op", "en,"],
                ["Lord,"],
                ["to"],
                ["thee:"],
            ],
            [["Thou"], ["know", "est"], ["our"], ["in", "fir", "mi", "ty;"]],
            [
                ["Pour"],
                ["out"],
                ["on"],
                ["all"],
                ["who"],
                ["seek"],
                ["thy"],
                ["face"],
            ],
            [
                ["A", "bun", "dance"],
                ["of"],
                ["thy"],
                ["pard", "'ning"],
                ["grace."],
            ],
            [
                ["Our"],
                ["sins"],
                ["are"],
                ["ma", "ny,"],
                ["this"],
                ["we"],
                ["know;"],
            ],
            [
                ["Spare"],
                ["us,"],
                ["good"],
                ["Lord,"],
                ["thy"],
                ["mer", "cy"],
                ["show;"],
            ],
            [
                ["And"],
                ["for"],
                ["the"],
                ["ho", "nour"],
                ["of"],
                ["thy"],
                ["name"],
            ],
            [
                ["Our"],
                ["faint", "ing"],
                ["souls"],
                ["to"],
                ["life"],
                ["re", "claim."],
            ],
            [
                ["Give"],
                ["us"],
                ["the"],
                ["self-", "con", "trol"],
                ["that"],
                ["springs"],
            ],
            [
                ["From"],
                ["di", "sci", "pline"],
                ["of"],
                ["out", "ward"],
                ["things,"],
            ],
            [["That"], ["fast", "ing"], ["in", "ward"], ["se", "cret", "ly"]],
            [
                ["The"],
                ["soul"],
                ["may"],
                ["pure", "ly"],
                ["dwell"],
                ["with"],
                ["thee."],
            ],
            [["We"], ["pray"], ["thee,"], ["Ho", "ly"], ["Tri", "ni", "ty,"]],
            [["One"], ["God,"], ["un", "chang", "ing"], ["U", "ni", "ty,"]],
            [
                ["That"],
                ["we"],
                ["from"],
                ["this"],
                ["our"],
                ["ab", "sti", "nence"],
            ],
            [
                ["May"],
                ["reap"],
                ["the"],
                ["fruits"],
                ["of"],
                ["pe", "ni", "tence."],
            ],
        ],
        tune: [
            ["32", "3", "54", "5", "34", "43", "23", "3"],
            ["54", "56", "654", "3", "54", "34", "32", "2"],
            ["2", "3", "4", "54", "3", "54", "56", "6"],
            ["23", "56", "4", "54", "3", "43", "23", "3"],
        ],
        amen: ["34", "323"],
        clef: "f5",
        tone: "2",
    },
    "now-is-the-healing-time-decreed": {
        // lent, evening, lent 3 until passion sunday
        title: "Ecce tempus idoneum",
        text: [
            [
                ["NOW"],
                ["is"],
                ["the"],
                ["heal", "ing"],
                ["time"],
                ["de", "creed"],
            ],
            [
                ["For"],
                ["sins"],
                ["of"],
                ["heart,"],
                ["of"],
                ["word"],
                ["or"],
                ["deed,"],
            ],
            [
                ["when"],
                ["we"],
                ["in"],
                ["hum", "ble"],
                ["fear"],
                ["re", "cord"],
            ],
            [
                ["The"],
                ["wrong"],
                ["that"],
                ["we"],
                ["have"],
                ["done"],
                ["the"],
                ["Lord;"],
            ],
            [["Who,"], ["al", "way"], ["mer", "ci", "ful"], ["and"], ["good,"]],
            [
                ["Has"],
                ["borne"],
                ["so"],
                ["long"],
                ["our"],
                ["way", "ward"],
                ["mood,"],
            ],
            [["Nor"], ["cut"], ["us"], ["off"], ["un", "spar", "ing", "ly"]],
            [["In"], ["our"], ["so"], ["great"], ["i", "ni", "qui", "ty."]],
            [
                ["There", "fore"],
                ["with"],
                ["fast", "ing"],
                ["and"],
                ["with"],
                ["prayer,"],
            ],
            [["Our"], ["sec", "ret"], ["sor", "row"], ["we"], ["de", "clare;"]],
            [
                ["With"],
                ["all"],
                ["good"],
                ["striv", "ing"],
                ["seek"],
                ["his"],
                ["face,"],
            ],
            [
                ["And"],
                ["low", "ly"],
                ["hear", "ted"],
                ["plead"],
                ["for"],
                ["grace."],
            ],
            [
                ["Cleanse"],
                ["us,"],
                ["O"],
                ["Lord,"],
                ["from"],
                ["ev", "'ry"],
                ["stain,"],
            ],
            [
                ["Help"],
                ["us"],
                ["the"],
                ["meed"],
                ["of"],
                ["praise"],
                ["to"],
                ["gain,"],
            ],
            [
                ["Till"],
                ["with"],
                ["the"],
                ["An", "gels"],
                ["linked"],
                ["in"],
                ["love"],
            ],
            [
                ["Joy", "ful"],
                ["we"],
                ["tread"],
                ["thy"],
                ["courts"],
                ["a", "bove."],
            ],
            [
                ["Fa", "ther"],
                ["and"],
                ["Son"],
                ["and"],
                ["Spi", "rit"],
                ["blest,"],
            ],
            [
                ["To"],
                ["thee"],
                ["be"],
                ["ev", "'ry"],
                ["prayer"],
                ["ad", "drest,"],
            ],
            [
                ["Who"],
                ["art"],
                ["in"],
                ["three", "fold"],
                ["Name"],
                ["a", "dored,"],
            ],
            [
                ["From"],
                ["age"],
                ["to"],
                ["age,"],
                ["the"],
                ["on", "ly"],
                ["Lord."],
            ],
        ],
        tune: [
            ["4", "56", "65", "7", "65", "4", "5", "6"],
            ["4", "6", "4", "5", "2", "3", "2", "1"],
            ["4", "6", "5", "7", "8", "7", "65", "4"],
            ["57", "4", "5", "3", "45", "4", "32", "2"],
        ],
        amen: ["23", "212"],
        clef: "c7",
        tone: "3",
    },
    "the-glory-of-these-forty-days": {
        // lent, morning, lent 3 until lent 5
        title: "Clarum decus jejunii",
        text: [
            [
                ["THE"],
                ["glo", "ry"],
                ["of"],
                ["these"],
                ["for", "ty"],
                ["days"],
            ],
            [
                ["We"],
                ["ce", "le", "brate"],
                ["with"],
                ["songs"],
                ["of"],
                ["praise;"],
            ],
            [
                ["For"],
                ["Christ,"],
                ["by"],
                ["whom"],
                ["all"],
                ["things"],
                ["were"],
                ["made,"],
            ],
            [
                ["Him", "self"],
                ["has"],
                ["fast", "ed"],
                ["and"],
                ["has"],
                ["prayed."],
            ],
            [["A", "lone"], ["and"], ["fast", "ing"], ["Mo", "ses"], ["saw"]],
            [
                ["The"],
                ["lov", "ing"],
                ["God"],
                ["who"],
                ["gave"],
                ["the"],
                ["Law;"],
            ],
            [["And"], ["to"], ["E", "li", "jah,"], ["fast", "ing,"], ["came"]],
            [
                ["The"],
                ["steeds"],
                ["and"],
                ["cha", "ri", "ots"],
                ["of"],
                ["flame."],
            ],
            [
                ["So"],
                ["Dan", "iel"],
                ["trained"],
                ["his"],
                ["mys", "tic"],
                ["sight,"],
            ],
            [
                ["De", "li", "vered"],
                ["from"],
                ["the"],
                ["li", "ons"],
                ["might;"],
            ],
            [
                ["And"],
                ["John,"],
                ["the"],
                ["bride", "groom's"],
                ["friend,"],
                ["be", "came"],
            ],
            [["The"], ["he", "rald"], ["of"], ["Mes", "si", "ah's"], ["name."]],
            [
                ["Then"],
                ["grant"],
                ["us,"],
                ["Lord,"],
                ["like"],
                ["them"],
                ["to"],
                ["be"],
            ],
            [
                ["Full"],
                ["oft"],
                ["in"],
                ["fast"],
                ["and"],
                ["prayer"],
                ["with"],
                ["thee;"],
            ],
            [
                ["Our"],
                ["spi", "rits"],
                ["strength", "ened"],
                ["with"],
                ["thy"],
                ["grace,"],
            ],
            [
                ["And"],
                ["give"],
                ["us"],
                ["joy"],
                ["to"],
                ["see"],
                ["thy"],
                ["face."],
            ],
            [
                ["Fa", "ther"],
                ["and"],
                ["Son"],
                ["and"],
                ["Spi", "rit"],
                ["blest,"],
            ],
            [
                ["To"],
                ["thee"],
                ["be"],
                ["ev", "'ry"],
                ["prayer"],
                ["ad", "drest,"],
            ],
            [
                ["Who"],
                ["art"],
                ["in"],
                ["three", "fold"],
                ["Name"],
                ["a", "dored,"],
            ],
            [
                ["From"],
                ["age"],
                ["to"],
                ["age,"],
                ["the"],
                ["on", "ly"],
                ["Lord."],
            ],
        ],
        tune: [
            ["23", "3", "35", "2", "35", "54", "34", "4"],
            ["6", "54", "3", "4", "54", "3", "23", "3"],
            ["36", "3", "36", "5", "54", "34", "32", "2"],
            ["2", "3", "4", "54", "3", "43", "23", "3"],
        ],
        amen: ["34", "323"],
        clef: "f5",
        tone: "2",
    },
    "o-jesus-christ-from-thee-began": {
        // lent, morning, from lent 3 to lent 5
        title: "Jesu quadragenariae",
        text: [
            [
                ["O"],
                ["JE", "SUS"],
                ["Christ,"],
                ["from"],
                ["thee"],
                ["be", "gan"],
            ],
            [
                ["The"],
                ["heal", "ing"],
                ["for"],
                ["the"],
                ["soul"],
                ["of"],
                ["man"],
            ],
            [
                ["By"],
                ["fast", "ing"],
                ["sought,"],
                ["by"],
                ["fast", "ing"],
                ["found,"],
            ],
            [
                ["Through"],
                ["for", "ty"],
                ["days"],
                ["of"],
                ["year", "ly"],
                ["round;"],
            ],
            [
                ["That"],
                ["he"],
                ["who"],
                ["fell"],
                ["from"],
                ["high"],
                ["delight,"],
            ],
            [
                ["Borne"],
                ["down"],
                ["to"],
                ["sen", "sual"],
                ["ap", "pe", "tite,"],
            ],
            [
                ["By"],
                ["dint"],
                ["of"],
                ["stern"],
                ["con", "trol"],
                ["may"],
                ["rise"],
            ],
            [
                ["To"],
                ["climb"],
                ["the"],
                ["hills"],
                ["of"],
                ["Pa", "ra", "dise."],
            ],
            [
                ["There", "fore"],
                ["be", "hold"],
                ["thy"],
                ["Church,"],
                ["O"],
                ["Lord,"],
            ],
            [["And"], ["grace"], ["of"], ["pe", "ni", "tence"], ["ac", "cord"]],
            [
                ["To"],
                ["all"],
                ["who"],
                ["seek"],
                ["with"],
                ["gen", "'rous"],
                ["tears"],
            ],
            [
                ["Re", "ne", "wal"],
                ["of"],
                ["their"],
                ["was", "ted"],
                ["years."],
            ],
            [
                ["For", "give"],
                ["the"],
                ["sin"],
                ["that"],
                ["we"],
                ["have"],
                ["done,"],
            ],
            [
                ["For", "give"],
                ["the"],
                ["course"],
                ["that"],
                ["we"],
                ["have"],
                ["run,"],
            ],
            [
                ["And"],
                ["show"],
                ["hence", "forth"],
                ["in"],
                ["e", "vil"],
                ["day"],
            ],
            [
                ["Thy", "self"],
                ["our"],
                ["suc", "cour"],
                ["and"],
                ["our"],
                ["stay."],
            ],
            [
                ["By"],
                ["now"],
                ["let"],
                ["ev", "'ry"],
                ["heart"],
                ["pre", "pare,"],
            ],
            [
                ["By"],
                ["sac", "ri", "fice"],
                ["of"],
                ["fast"],
                ["and"],
                ["prayer,"],
            ],
            [["To"], ["keep"], ["with"], ["joy"], ["mag", "ni", "fi", "cal"]],
            [["The"], ["so", "lemn"], ["Eas", "ter"], ["fes", "ti", "val."]],
            [
                ["Fa", "ther"],
                ["and"],
                ["Son"],
                ["and"],
                ["Spi", "rit"],
                ["blest,"],
            ],
            [
                ["To"],
                ["thee"],
                ["be"],
                ["ev", "'ry"],
                ["prayer"],
                ["ad", "drest,"],
            ],
            [
                ["Who"],
                ["art"],
                ["in"],
                ["three", "fold"],
                ["Name"],
                ["a", "dored,"],
            ],
            [
                ["From"],
                ["age"],
                ["to"],
                ["age,"],
                ["the"],
                ["on", "ly"],
                ["Lord."],
            ],
        ],
        tune: [
            ["3", "2345", "4", "31", "3", "23", "2", "2"],
            ["4", "56", "5", "43", "4", "43", "2", "21"],
            ["01", "1", "10", "1", "3", "12", "2", "2"],
            ["4", "45", "4", "31", "3", "23", "2", "2"],
        ],
        amen: ["23", "212"],
        clef: "c7",
        tone: "4",
    },
    "the-royal-banners-forward-go": {
        // passiontide, evening
        title: "Vexilla Regis prodeunt",
        text: [
            [["THE"], ["roy", "al"], ["ban", "ners"], ["for", "ward"], ["go;"]],
            [
                ["The"],
                ["Cross"],
                ["shines"],
                ["forth"],
                ["in"],
                ["my", "stic"],
                ["glow;"],
            ],
            [
                ["Where"],
                ["he"],
                ["in"],
                ["flesh,"],
                ["our"],
                ["flesh"],
                ["who"],
                ["made,"],
            ],
            [
                ["Our"],
                ["sen", "tence"],
                ["bore,"],
                ["our"],
                ["ran", "som"],
                ["paid:"],
            ],
            [
                ["Where"],
                ["deep"],
                ["for"],
                ["us"],
                ["the"],
                ["spear"],
                ["was"],
                ["dyed,"],
            ],
            [
                ["Life's"],
                ["tor", "rent"],
                ["rush", "ing"],
                ["from"],
                ["his"],
                ["side,"],
            ],
            [
                ["To"],
                ["wash"],
                ["us"],
                ["in"],
                ["that"],
                ["pre", "cious"],
                ["flood,"],
            ],
            [
                ["Where"],
                ["ming", "led"],
                ["Wa", "ter"],
                ["flowed,"],
                ["and"],
                ["Blood."],
            ],
            [
                ["Ful", "filled"],
                ["is"],
                ["all"],
                ["that"],
                ["Da", "vid"],
                ["told"],
            ],
            [
                ["In"],
                ["true"],
                ["pro", "phe", "tic"],
                ["song"],
                ["of"],
                ["old;"],
            ],
            [
                ["A", "midst"],
                ["the"],
                ["na", "tions,"],
                ["God,"],
                ["saith"],
                ["he,"],
            ],
            [
                ["Hath"],
                ["reigned"],
                ["and"],
                ["tri", "umphed"],
                ["from"],
                ["the"],
                ["tree."],
            ],
            [
                ["O"],
                ["Tree"],
                ["of"],
                ["beau", "ty,"],
                ["Tree"],
                ["of"],
                ["light!"],
            ],
            [
                ["O"],
                ["Tree"],
                ["with"],
                ["roy", "al"],
                ["pur", "ple"],
                ["dight!"],
            ],
            [
                ["E", "lect"],
                ["on"],
                ["whose"],
                ["tri", "umph", "al"],
                ["breast"],
            ],
            [
                ["Those"],
                ["ho", "ly"],
                ["limbs"],
                ["should"],
                ["find"],
                ["their"],
                ["rest:"],
            ],
            [
                ["On"],
                ["whose"],
                ["dear"],
                ["arms,"],
                ["so"],
                ["wide", "ly"],
                ["flung,"],
            ],
            [
                ["The"],
                ["weight"],
                ["of"],
                ["this"],
                ["world's"],
                ["ran", "som"],
                ["hung;"],
            ],
            [
                ["The"],
                ["price"],
                ["of"],
                ["hu", "man", "kind"],
                ["to"],
                ["pay,"],
            ],
            [
                ["And"],
                ["spoil"],
                ["the"],
                ["spoil", "er"],
                ["of"],
                ["his"],
                ["prey."],
            ],
            [
                ["O"],
                ["Cross,"],
                ["our"],
                ["one"],
                ["re", "li", "ance"],
                ["hail!"],
            ],
            [
                ["So"],
                ["may"],
                ["thy"],
                ["pow'r"],
                ["with"],
                ["us"],
                ["av", "ail"],
            ],
            [
                ["To"],
                ["give"],
                ["new"],
                ["vir", "tue"],
                ["to"],
                ["the"],
                ["saint,"],
            ],
            [["And"], ["par", "don"], ["to"], ["the"], ["pe", "ni", "tent."]],
            [
                ["To"],
                ["thee,"],
                ["e", "ter", "al"],
                ["Three"],
                ["in"],
                ["One,"],
            ],
            [
                ["Let"],
                ["ho", "mage"],
                ["meet"],
                ["by"],
                ["all"],
                ["be"],
                ["done:"],
            ],
            [
                ["Whom"],
                ["by"],
                ["the"],
                ["Cross"],
                ["thou"],
                ["dost"],
                ["re", "store,"],
            ],
            [["Pre", "serve"], ["and"], ["gov", "ern"], ["ev", "er", "more."]],
        ],
        tune: [
            ["3", "46b", "6b", "543", "4", "454", "3", "21"],
            ["4", "4", "5", "321", "3", "23", "10", "01"],
            ["1", "1", "3", "10", "3", "345", "4", "43"],
            ["3", "356b54", "5", "321", "3", "23", "10", "01"],
        ],
        amen: ["12", "101"],
        clef: "c7",
        tone: "1",
    },
    "sing-my-tongue-the-glorious-battle": {
        // passiontide, morning
        title: "Pange lingua gloriosi lauream certaminus",
        text: [
            [
                ["SING,"],
                ["my"],
                ["tongue,"],
                ["the"],
                ["glor", "ious"],
                ["bat", "tle,"],
            ],
            [["Sing"], ["the"], ["end", "ing"], ["of"], ["the"], ["fray;"]],
            [
                ["Now"],
                ["a", "bove"],
                ["the"],
                ["Cross,"],
                ["the"],
                ["tro", "phy,"],
            ],
            [["Sound"], ["the"], ["loud"], ["tri", "umph", "ant"], ["lay:"]],
            [
                ["Tell"],
                ["how"],
                ["Christ,"],
                ["the"],
                ["world's"],
                ["Re", "dee", "mer,"],
            ],
            [["As"], ["a"], ["Vic", "tim"], ["won"], ["the"], ["day."]],
            [["God"], ["in"], ["pi", "ty"], ["saw"], ["man"], ["fall", "en,"]],
            [["Shamed"], ["and"], ["sunk"], ["in"], ["mi", "se", "ry,"]],
            [
                ["When"],
                ["he"],
                ["fell"],
                ["on"],
                ["death"],
                ["by"],
                ["tast", "ing"],
            ],
            [["Fruit"], ["of"], ["the"], ["for", "bid", "den"], ["tree;"]],
            [["Then"], ["a", "no", "ther"], ["tree"], ["was"], ["cho", "sen"]],
            [
                ["Which"],
                ["the"],
                ["world"],
                ["from"],
                ["death"],
                ["should"],
                ["free."],
            ],
            [
                ["Thus"],
                ["the"],
                ["scheme"],
                ["of"],
                ["our"],
                ["sal", "va", "tion"],
            ],
            [["Was"], ["of"], ["old"], ["in"], ["or", "der"], ["laid,"]],
            [["That"], ["the"], ["ma", "ni", "fold"], ["de", "cei", "ver's"]],
            [["Art"], ["by"], ["art"], ["might"], ["be"], ["out", "weighed,"]],
            [
                ["And"],
                ["the"],
                ["lure"],
                ["the"],
                ["foe"],
                ["put"],
                ["for", "ward"],
            ],
            [["In", "to"], ["means"], ["of"], ["heal", "ing"], ["made."]],
            [
                ["There", "fore"],
                ["when"],
                ["the-", "appoint", "ed"],
                ["full", "ness"],
            ],
            [["Of"], ["the"], ["ho", "ly"], ["time"], ["was"], ["come,"]],
            [
                ["He"],
                ["was"],
                ["sent"],
                ["who"],
                ["mak", "eth"],
                ["all"],
                ["things"],
            ],
            [["Forth"], ["from"], ["God's"], ["et", "er", "nal"], ["home;"]],
            [
                ["Thus"],
                ["he"],
                ["came"],
                ["to"],
                ["earth"],
                ["in", "car", "nate,"],
            ],
            [["Off", "spring"], ["of"], ["a"], ["maid", "en's"], ["womb."]],
            [["To"], ["the"], ["Tri", "ni", "ty"], ["be"], ["glo", "ry"]],
            [["Ev", "er", "last", "ing"], ["as"], ["is"], ["meet;"]],
            [["E", "qual"], ["to"], ["the"], ["Fa", "ther,"], ["e", "qual"]],
            [["To"], ["the"], ["Son"], ["and"], ["Pa", "ra", "clete:"]],
            [["Tri", "nal"], ["U", "ni", "ty,"], ["whose"], ["prai", "ses"]],
            [["All"], ["cre", "a", "ted"], ["things"], ["re", "peat."]],
        ],
        tune: [
            ["3", "3", "3", "2", "5", "5", "68", "8"],
            ["89", "8", "8", "8", "6", "8", "765"],
            ["5", "6", "8", "7", "6", "5", "6", "6"],
            ["6", "7", "5", "4", "3", "6", "62"],
            ["5", "5", "5", "3", "5", "6", "6", "5"],
            ["6", "7", "5", "65", "4b", "2", "3"],
        ],
        amen: ["34", "323"],
        clef: "c5",
        tone: "3",
    },
    "thirty-years-among-us-dwelling": {
        // passiontide, morning
        title: "Lustra sex qui jam peracts",
        text: [
            [
                ["THIR", "TY"],
                ["years"],
                ["a", "mong"],
                ["us"],
                ["dwell", "ing,"],
            ],
            [["His"], ["ap", "poin", "ted"], ["time"], ["ful", "filled,"]],
            [
                ["Born"],
                ["for"],
                ["this,"],
                ["he"],
                ["meets"],
                ["his"],
                ["Pass", "ion,"],
            ],
            [["For"], ["that"], ["this"], ["he"], ["free", "ly"], ["willed,"]],
            [
                ["On"],
                ["the"],
                ["Cross"],
                ["the"],
                ["Lamb"],
                ["is"],
                ["lift", "ed"],
            ],
            [
                ["Where"],
                ["his"],
                ["life-", "blood"],
                ["shall"],
                ["be"],
                ["spilled."],
            ],
            [
                ["He"],
                ["en", "dured"],
                ["the"],
                ["nails,"],
                ["the"],
                ["spit", "ting,"],
            ],
            [["Vi", "ne", "gar,"], ["and"], ["spear,"], ["and"], ["reed;"]],
            [["From"], ["that"], ["ho", "ly"], ["Bo", "dy"], ["bro", "ken"]],
            [["Blood"], ["and"], ["wa", "ter"], ["forth"], ["pro", "ceed;"]],
            [
                ["Earth,"],
                ["and"],
                ["stars,"],
                ["and"],
                ["sky,"],
                ["and"],
                ["o", "cean"],
            ],
            [
                ["By"],
                ["that"],
                ["flood"],
                ["from"],
                ["stain"],
                ["are"],
                ["freed."],
            ],
            [
                ["Faith", "ful"],
                ["Cross!"],
                ["A", "bove"],
                ["all"],
                ["o", "ther,"],
            ],
            [["One"], ["and"], ["on", "ly"], ["no", "ble"], ["tree!"]],
            [
                ["None"],
                ["in"],
                ["fol", "iage,"],
                ["none"],
                ["in"],
                ["bloss", "om,"],
            ],
            [["None"], ["in"], ["fruit"], ["thy"], ["peer"], ["may"], ["be;"]],
            [
                ["Sweet", "est"],
                ["wood"],
                ["and"],
                ["sweet", "est"],
                ["i", "ron!"],
            ],
            [["Sweet", "est"], ["weight"], ["is"], ["hung"], ["on"], ["thee."]],
            [
                ["Bend"],
                ["thy"],
                ["boughs,"],
                ["O"],
                ["Tree"],
                ["of"],
                ["Glo", "ry!"],
            ],
            [["Thy"], ["re", "lax", "ing"], ["sin", "ews"], ["bend;"]],
            [["For"], ["a", "wile"], ["the"], ["an", "cient"], ["rig", "our"]],
            [["That"], ["thy"], ["birth"], ["be", "stowed,"], ["sus", "pend;"]],
            [
                ["And"],
                ["the"],
                ["King"],
                ["of"],
                ["heav'n", "ly"],
                ["beau", "ty"],
            ],
            [["On"], ["thy"], ["bo", "som"], ["gent", "ly"], ["tend!"]],
            [
                ["Thou"],
                ["a", "lone"],
                ["wast"],
                ["count", "ed"],
                ["wor", "thy"],
            ],
            [["This"], ["world's"], ["ran", "som"], ["to"], ["up", "hold;"]],
            [
                ["For"],
                ["a"],
                ["ship", "wreck'd"],
                ["race"],
                ["pre", "par", "ing"],
            ],
            [["Har", "bour,"], ["like"], ["the"], ["Ark"], ["of"], ["old;"]],
            [
                ["With"],
                ["the"],
                ["sa", "cred"],
                ["Blood"],
                ["a", "noin", "ted"],
            ],
            [
                ["From"],
                ["the"],
                ["smit", "ten"],
                ["Lamb"],
                ["that"],
                ["rolled."],
            ],
            [["To"], ["the"], ["Tri", "ni", "ty"], ["be"], ["glo", "ry"]],
            [["Ev", "er", "last", "ing"], ["as"], ["is"], ["meet;"]],
            [["E", "qual"], ["to"], ["the"], ["Fa", "ther,"], ["e", "qual"]],
            [["To"], ["the"], ["Son"], ["and"], ["Pa", "ra", "clete:"]],
            [["Tri", "nal"], ["U", "ni", "ty,"], ["whose"], ["prai", "ses"]],
            [["All"], ["cre", "a", "ted"], ["things"], ["re", "peat."]],
        ],
        tune: [
            ["3", "3", "3", "2", "5", "5", "68", "8"],
            ["89", "8", "8", "8", "6", "8", "765"],
            ["5", "6", "8", "7", "6", "5", "6", "6"],
            ["6", "7", "5", "4", "3", "6", "62"],
            ["5", "5", "5", "3", "5", "6", "6", "5"],
            ["6", "7", "5", "65", "4b", "2", "3"],
        ],
        amen: ["34", "323"],
        clef: "c5",
        tone: "3",
    },
    "lord-of-creation-bow-thine-ear": {
        title: "Annue Christe",
        text: [
            [
                ["LORD"],
                ["of"],
                ["cre", "a", "tion,"],
                ["bow"],
                ["Thine"],
                ["ear,"],
                ["O"],
                ["Christ,"],
                ["to"],
                ["hear"],
            ],
            [
                ["The"],
                ["in", "ter", "cess", "ion"],
                ["of"],
                ["Thy"],
                ["ser", "vant"],
                ["true"],
                ["and"],
                ["dear,"],
            ],
            [
                ["That"],
                ["we"],
                ["un", "wor", "thy,"],
                ["who"],
                ["have"],
                ["tres", "passed"],
                ["in"],
                ["Thy"],
                ["sight,"],
            ],
            [
                ["May"],
                ["live"],
                ["be", "fore"],
                ["Thee"],
                ["where"],
                ["he"],
                ["dwells"],
                ["in"],
                ["glo", "rious"],
                ["light."],
            ],
            [
                ["O"],
                ["God"],
                ["our"],
                ["Sav", "ior,"],
                ["look"],
                ["on"],
                ["Thine"],
                ["in", "he", "ri", "tance,"],
            ],
            [
                ["Sealed"],
                ["by"],
                ["the"],
                ["fa", "vor"],
                ["shin", "ing"],
                ["from"],
                ["Thy"],
                ["coun", "te", "nance;"],
            ],
            [
                ["That"],
                ["no"],
                ["false"],
                ["spi", "rit"],
                ["bring"],
                ["to"],
                ["naught"],
                ["the"],
                ["souls"],
                ["of"],
                ["price"],
            ],
            [
                ["Bought"],
                ["by"],
                ["the"],
                ["me", "rit"],
                ["of"],
                ["Thy"],
                ["per", "fect"],
                ["sac", "ri", "fice."],
            ],
            [
                ["We"],
                ["bear"],
                ["the"],
                ["bur", "den"],
                ["of"],
                ["our"],
                ["guilt"],
                ["and"],
                ["en", "mi", "ty,"],
            ],
            [
                ["Un", "til"],
                ["Thy"],
                ["par", "don"],
                ["lift"],
                ["the"],
                ["heart"],
                ["from"],
                ["sla", "ve", "ry;"],
            ],
            [
                ["Then"],
                ["through"],
                ["the"],
                ["spend", "ing"],
                ["of"],
                ["Thy"],
                ["life"],
                ["blood,"],
                ["King"],
                ["of"],
                ["grace,"],
            ],
            [
                ["Grant"],
                ["us"],
                ["un", "end", "ing"],
                ["tri", "umph"],
                ["in"],
                ["Thy"],
                ["ho", "ly"],
                ["place."],
            ],
            [
                ["To"],
                ["Thee"],
                ["the"],
                ["glor", "ious"],
                ["Christ,"],
                ["our"],
                ["Sav", "ior"],
                ["ma", "ni", "fest,"],
            ],
            [
                ["All"],
                ["wreaths"],
                ["vic", "to", "rious,"],
                ["praise"],
                ["and"],
                ["wor", "ship"],
                ["be"],
                ["ad", "drest,"],
            ],
            [
                ["Whom"],
                ["with"],
                ["the"],
                ["li", "ving"],
                ["Fa", "ther"],
                ["humb", "ly"],
                ["we"],
                ["a", "dore,"],
            ],
            [
                ["And"],
                ["the"],
                ["life"],
                ["giv", "ing"],
                ["Spi", "rit,"],
                ["God"],
                ["for", "ev", "er", "more."],
            ],
        ],
        tune: [
            [
                "1556",
                "4",
                "56",
                "7",
                "65",
                "8",
                "7",
                "65",
                "4",
                "7",
                "654",
                "5",
            ],
            [
                "5",
                "5765",
                "4",
                "343",
                "21",
                "4",
                "56",
                "7",
                "65",
                "4",
                "5",
                "5",
            ],
            ["8", "76", "78", "76", "5", "6", "7", "5", "6", "4", "5", "5"],
            ["5", "5765", "4", "343", "21", "2", "3", "1", "2", "0", "1", "1"],
        ],
        amen: ["12", "101"],
        clef: "c7",
        tone: "1",
    },
    "the-god-whom-earth-and-sea-and-sky": {
        title: "Quem terra, pontus, aethera",
        text: [
            [
                ["THE"],
                ["God"],
                ["whom"],
                ["earth"],
                ["and"],
                ["sea"],
                ["and"],
                ["sky"],
            ],
            [["A", "dore"], ["and"], ["laud"], ["and"], ["mag", "ni", "fy,"]],
            [
                ["Whose"],
                ["might"],
                ["they"],
                ["own,"],
                ["whose"],
                ["praise"],
                ["they"],
                ["swell,"],
            ],
            [
                ["In"],
                ["Ma", "ry's"],
                ["womb"],
                ["vouch", "safed"],
                ["to"],
                ["dwell."],
            ],
            [
                ["The"],
                ["Lord"],
                ["whom"],
                ["sun"],
                ["and"],
                ["moon"],
                ["o", "bey,"],
            ],
            [
                ["Whom"],
                ["all"],
                ["things"],
                ["serve"],
                ["from"],
                ["day"],
                ["to"],
                ["day,"],
            ],
            [
                ["Was"],
                ["by"],
                ["the"],
                ["Ho", "ly"],
                ["Ghost"],
                ["con", "ceived"],
            ],
            [
                ["Of"],
                ["her"],
                ["who"],
                ["through"],
                ["his"],
                ["grace"],
                ["be", "lieved."],
            ],
            [
                ["How"],
                ["blest"],
                ["that"],
                ["Mo", "ther,"],
                ["in"],
                ["whose"],
                ["shrine"],
            ],
            [
                ["The"],
                ["world's"],
                ["Cre", "a", "tor,"],
                ["Lord"],
                ["di", "vine,"],
            ],
            [
                ["Whose"],
                ["hand"],
                ["con", "tains"],
                ["the"],
                ["earth"],
                ["and"],
                ["sky,"],
            ],
            [
                ["Once"],
                ["deigned,"],
                ["as"],
                ["in"],
                ["his"],
                ["ark,"],
                ["to"],
                ["lie."],
            ],
            [
                ["Blest"],
                ["in"],
                ["the"],
                ["mess", "age"],
                ["Ga", "briel"],
                ["brought,"],
            ],
            [
                ["Blest"],
                ["by"],
                ["the"],
                ["work"],
                ["the"],
                ["Spi", "rit"],
                ["wrought;"],
            ],
            [
                ["From"],
                ["whom"],
                ["the"],
                ["great"],
                ["De", "sire"],
                ["of"],
                ["earth"],
            ],
            [
                ["Took"],
                ["hu", "man"],
                ["flesh"],
                ["and"],
                ["hu", "man"],
                ["birth."],
            ],
            [
                ["O"],
                ["Lord,"],
                ["the"],
                ["Vir", "gin-", "born,"],
                ["to"],
                ["thee"],
            ],
            [["E", "ter", "nal"], ["praise"], ["and"], ["glo", "ry"], ["be,"]],
            [
                ["Whom"],
                ["with"],
                ["the"],
                ["Fa", "ther"],
                ["we"],
                ["a", "dore"],
            ],
            [["And"], ["Ho", "ly"], ["Ghost"], ["for"], ["ev", "er", "more."]],
        ],
        tune: [
            ["4", "4323", "10", "4", "46b", "6b5", "4", "5"],
            ["7", "76b", "5", "6b5", "4", "54", "34", "4"],
            ["47", "7", "76b", "7", "787", "6b5", "43", "4543"],
            ["6b5", "6b7", "5", "6b5", "4", "54", "34", "4"],
        ],
        amen: ["45", "434"],
        clef: "c7",
        tone: "1",
    },
    "all-prophets-hail-thee": {
        title: "Quod chorus vatum",
        text: [
            [
                ["ALL"],
                ["pro", "phets"],
                ["hail"],
                ["thee,"],
                ["from"],
                ["of"],
                ["old"],
                ["an", "noun", "cing,"],
            ],
            [
                ["By"],
                ["the"],
                ["in", "breath", "ed"],
                ["Spi", "rit"],
                ["of"],
                ["the"],
                ["Fa", "ther,"],
            ],
            [
                ["God's"],
                ["Mo", "ther,"],
                ["bring", "ing"],
                ["pro", "phe", "cies"],
                ["to"],
                ["full", "ness"],
            ],
            [["Ma", "ry"], ["the"], ["mai", "den."]],
            [
                ["Thou"],
                ["the"],
                ["true"],
                ["Vir", "gin"],
                ["Mo", "ther"],
                ["of"],
                ["the"],
                ["High", "est,"],
            ],
            [
                ["Bear", "ing"],
                ["in", "car", "nate"],
                ["God"],
                ["in"],
                ["awed"],
                ["o", "be", "dience,"],
            ],
            [
                ["Meek", "ly"],
                ["ac", "cept", "est"],
                ["for"],
                ["a"],
                ["sin", "less"],
                ["off", "spring"],
            ],
            [["Pu", "ri", "fi", "ca", "tion."]],
            [
                ["In"],
                ["the"],
                ["high"],
                ["tem", "ple"],
                ["Si", "me", "on"],
                ["re", "ceives"],
                ["thee,"],
            ],
            [
                ["Takes"],
                ["to"],
                ["his"],
                ["bent"],
                ["arms"],
                ["with"],
                ["a"],
                ["ho", "ly"],
                ["rap", "ture"],
            ],
            [
                ["That"],
                ["pro", "mised"],
                ["Sav", "ior,"],
                ["vis", "ion"],
                ["of"],
                ["re", "demp", "tion,"],
            ],
            [["Christ"], ["long"], ["a", "wait", "ed."]],
            [
                ["Now"],
                ["the"],
                ["fair"],
                ["realm"],
                ["of"],
                ["pa", "ra", "dise"],
                ["at", "tain", "ing,"],
            ],
            [
                ["And"],
                ["to"],
                ["thy"],
                ["Son's"],
                ["throne,"],
                ["Mo", "ther"],
                ["of"],
                ["the-", "Eter", "nal,"],
            ],
            [
                ["Rais", "ed"],
                ["all"],
                ["glor", "ious,"],
                ["yet"],
                ["in"],
                ["earth's"],
                ["de", "vo", "tion"],
            ],
            [["Join"], ["with"], ["us"], ["al", "ways."]],
            [
                ["Glo", "ry"],
                ["and"],
                ["wor", "ship"],
                ["to"],
                ["the"],
                ["Lord"],
                ["of"],
                ["all"],
                ["things"],
            ],
            [
                ["Pay"],
                ["we"],
                ["un", "rest", "ing,"],
                ["who"],
                ["a", "lone"],
                ["a", "dor", "ed,"],
            ],
            [
                ["Fa", "ther"],
                ["and"],
                ["Son"],
                ["and"],
                ["Spi", "rit,"],
                ["in"],
                ["the"],
                ["high", "est"],
            ],
            [
                ["Reign", "eth"],
                ["e", "ter", "nal."],
            ],
        ],
        tune: [
            ["13", "1", "1", "0", "1", "3", "3", "1", "2", "2", "1"],
            ["156b", "5", "5", "54", "45", "3", "45", "4", "34", "432", "1"],
            ["14", "32", "10", "1", "0", "32", "34", "32", "10", "12", "2"],
            ["13", "1", "1", "0", "1"],
        ],
        amen: ["12", "101"],
        clef: "c7",
        tone: "1",
    },
    "o-boundless-wisdom-god-most-high": {
        // Monday evening, ordinary time
        title: "Immense caeli Conditor",
        text: [
            [
                ["O"],
                ["BOUND", "LESS"],
                ["Wis", "dom,"],
                ["God"],
                ["most"],
                ["high,"],
            ],
            [
                ["O"],
                ["Ma", "ker"],
                ["of"],
                ["the"],
                ["earth"],
                ["and"],
                ["sky,"],
            ],
            [
                ["Who"],
                ["bid’st"],
                ["the"],
                ["par", "ted"],
                ["wa", "ters"],
                ["flow"],
            ],
            [
                ["In"],
                ["heav'n"],
                ["a", "bove,"],
                ["on"],
                ["earth"],
                ["be", "low."],
            ],
            [
                ["The"],
                ["streams"],
                ["on"],
                ["earth,"],
                ["the"],
                ["clouds"],
                ["in"],
                ["heav'n,"],
            ],
            [
                ["By"],
                ["Thee"],
                ["their"],
                ["ord", "er'd"],
                ["bounds"],
                ["were"],
                ["giv'n,"],
            ],
            [
                ["Lest"],
                ["’neath"],
                ["the-un", "temp", "er'd"],
                ["fires"],
                ["of"],
                ["day"],
            ],
            [
                ["The"],
                ["parch-", "ed"],
                ["soil"],
                ["should"],
                ["waste"],
                ["a", "way."],
            ],
            [
                ["E’en"],
                ["so"],
                ["on"],
                ["us"],
                ["who"],
                ["seek"],
                ["Thy"],
                ["face"],
            ],
            [
                ["Pour"],
                ["forth"],
                ["the"],
                ["wa", "ters"],
                ["of"],
                ["Thy"],
                ["grace;"],
            ],
            [
                ["Re", "new"],
                ["the"],
                ["fount"],
                ["of"],
                ["life"],
                ["with", "in,"],
            ],
            [
                ["And"],
                ["quench"],
                ["the"],
                ["wast", "ing"],
                ["fires"],
                ["of"],
                ["sin."],
            ],
            [
                ["Let"],
                ["faith"],
                ["di", "scern"],
                ["the-e", "ter", "nal"],
                ["Light"],
            ],
            [
                ["Be", "yond"],
                ["the"],
                ["dark", "ness"],
                ["of"],
                ["the"],
                ["night,"],
            ],
            [
                ["And"],
                ["through"],
                ["the"],
                ["mists"],
                ["of"],
                ["false", "hood"],
                ["see"],
            ],
            [
                ["The"],
                ["path"],
                ["of"],
                ["truth"],
                ["re", "vealed"],
                ["by"],
                ["Thee."],
            ],
            [
                ["O"],
                ["Fa", "ther,"],
                ["that"],
                ["we"],
                ["ask"],
                ["be"],
                ["done,"],
            ],
            [
                ["Through"],
                ["Je", "sus"],
                ["Christ,"],
                ["thine"],
                ["on", "ly"],
                ["Son;"],
            ],
            [
                ["Who,"],
                ["with"],
                ["the"],
                ["Ho", "ly"],
                ["Ghost"],
                ["and"],
                ["thee,"],
            ],
            [
                ["Doth"],
                ["live"],
                ["and"],
                ["reign"],
                ["et", "er", "nal", "ly."],
            ],
        ],
        tune: [
            ["5", "5", "6", "7", "6", "6", "5", "4"],
            ["6", "4", "5", "3", "2", "5", "5", "5"],
            ["5", "5", "6", "7", "6", "6", "5", "4"],
            ["6", "4", "5", "3", "2", "5", "3", "3"],
        ],
        amen: ["34", "323"],
        clef: "f5",
        tone: "2",
    },
    "earths-mighty-maker-whose-command": {
        // Tuesday evening, ordinary time
        title: "Telluris ingens Conditor",
        text: [
            [
                ["EARTH'S"],
                ["migh", "ty"],
                ["Ma", "ker,"],
                ["whose"],
                ["com", "mand"],
            ],
            [
                ["Raised"],
                ["from"],
                ["the"],
                ["sea"],
                ["the"],
                ["so", "lid"],
                ["land,"],
            ],
            [
                ["And"],
                ["drove"],
                ["each"],
                ["bill", "owy"],
                ["heap"],
                ["a", "way,"],
            ],
            [
                ["And"],
                ["bade"],
                ["the"],
                ["earth"],
                ["stand"],
                ["firm"],
                ["for"],
                ["aye:"],
            ],
            [
                ["That"],
                ["so,"],
                ["with"],
                ["flowers"],
                ["of"],
                ["gold", "en"],
                ["hue,"],
            ],
            [
                ["The"],
                ["seeds"],
                ["of"],
                ["each"],
                ["it"],
                ["might"],
                ["re", "new;"],
            ],
            [
                ["And"],
                ["fruit"],
                ["trees"],
                ["bear", "ing"],
                ["fruit"],
                ["might"],
                ["yield-"],
            ],
            [
                ["And"],
                ["plea", "sant"],
                ["pas", "ture"],
                ["of"],
                ["the"],
                ["field;"],
            ],
            [
                ["Our"],
                ["spi", "rit’s"],
                ["rank", "ling"],
                ["wounds"],
                ["ef", "face"],
            ],
            [
                ["With"],
                ["dew", "y"],
                ["fresh", "ness"],
                ["of"],
                ["Thy"],
                ["grace:"],
            ],
            [
                ["That"],
                ["grief"],
                ["may"],
                ["cleanse"],
                ["each"],
                ["deed"],
                ["of"],
                ["ill,"],
            ],
            [
                ["And"],
                ["o’er"],
                ["each"],
                ["lust"],
                ["may"],
                ["tri", "umph"],
                ["still."],
            ],
            [["Let"], ["ev", "ery"], ["soul"], ["thy"], ["law"], ["o", "bey,"]],
            [
                ["And"],
                ["keep"],
                ["from"],
                ["ev", "ery"],
                ["e", "vil"],
                ["way;"],
            ],
            [
                ["Re", "joice"],
                ["each"],
                ["pro", "mised"],
                ["good"],
                ["to"],
                ["win"],
            ],
            [
                ["And"],
                ["flee"],
                ["from"],
                ["ev", "ery"],
                ["mor", "tal"],
                ["sin."],
            ],
            [
                ["O"],
                ["Fa", "ther,"],
                ["that"],
                ["we"],
                ["ask"],
                ["be"],
                ["done,"],
            ],
            [
                ["Through"],
                ["Je", "sus"],
                ["Christ,"],
                ["thine"],
                ["on", "ly"],
                ["Son;"],
            ],
            [
                ["Who,"],
                ["with"],
                ["the"],
                ["Ho", "ly"],
                ["Ghost"],
                ["and"],
                ["thee,"],
            ],
            [
                ["Doth"],
                ["live"],
                ["and"],
                ["reign"],
                ["et", "er", "nal", "ly."],
            ],
        ],
        tune: [
            ["5", "5", "6", "7", "6", "6", "5", "4"],
            ["6", "4", "5", "3", "2", "5", "5", "5"],
            ["5", "5", "6", "7", "6", "6", "5", "4"],
            ["6", "4", "5", "3", "2", "5", "3", "3"],
        ],
        amen: ["34", "323"],
        clef: "f5",
        tone: "2",
    },
    "most-holy-lord-and-god-of-heaven": {
        // Wednesday evening, ordinary time
        title: "Coeli Deus sanctissime",
        text: [
            [
                ["MOST"],
                ["ho", "ly"],
                ["Lord"],
                ["and"],
                ["God"],
                ["of"],
                ["Heav'n,"],
            ],
            [
                ["Who"],
                ["to"],
                ["the"],
                ["glow", "ing"],
                ["sky"],
                ["hast"],
                ["giv'n"],
            ],
            [
                ["The"],
                ["fires"],
                ["that"],
                ["in"],
                ["the"],
                ["east"],
                ["are"],
                ["born"],
            ],
            [
                ["With"],
                ["grad", "ual"],
                ["splen", "dors"],
                ["of"],
                ["the"],
                ["morn;"],
            ],
            [
                ["Who,"],
                ["on"],
                ["the"],
                ["fourth"],
                ["day,"],
                ["didst"],
                ["re", "veal"],
            ],
            [
                ["The"],
                ["sun’s"],
                ["en", "kin", "dled"],
                ["flam", "ing"],
                ["wheel,"],
            ],
            [
                ["Didst"],
                ["set"],
                ["the"],
                ["moon"],
                ["her"],
                ["ord", "er'd"],
                ["ways,"],
            ],
            [
                ["And"],
                ["stars"],
                ["their"],
                ["ev", "er"],
                ["wind", "ing"],
                ["maze;"],
            ],
            [
                ["That"],
                ["each"],
                ["in"],
                ["its"],
                ["ap", "poin", "ted"],
                ["way"],
            ],
            [
                ["Might"],
                ["se", "pa", "rate"],
                ["the"],
                ["night"],
                ["from"],
                ["day,"],
            ],
            [
                ["And"],
                ["of"],
                ["the"],
                ["sea", "sons"],
                ["through"],
                ["the"],
                ["year"],
            ],
            [
                ["The"],
                ["well"],
                ["re", "mem", "bered"],
                ["signs"],
                ["de", "clare;"],
            ],
            [["Il", "lu", "min", "ate"], ["our"], ["hearts"], ["with", "in,"]],
            [
                ["And"],
                ["cleanse"],
                ["our"],
                ["minds"],
                ["from"],
                ["stain"],
                ["of"],
                ["sin;"],
            ],
            [["Un", "bur", "dened"], ["of"], ["our"], ["guil", "ty"], ["load"]],
            [
                ["May"],
                ["we"],
                ["un", "fet", "tered"],
                ["serve"],
                ["our"],
                ["God."],
            ],
            [
                ["O"],
                ["Fa", "ther,"],
                ["that"],
                ["we"],
                ["ask"],
                ["be"],
                ["done,"],
            ],
            [
                ["Through"],
                ["Je", "sus"],
                ["Christ,"],
                ["thine"],
                ["on", "ly"],
                ["Son;"],
            ],
            [
                ["Who,"],
                ["with"],
                ["the"],
                ["Ho", "ly"],
                ["Ghost"],
                ["and"],
                ["thee,"],
            ],
            [
                ["Doth"],
                ["live"],
                ["and"],
                ["reign"],
                ["et", "er", "nal", "ly."],
            ],
        ],
        tune: [
            ["5", "5", "6", "7", "6", "6", "5", "4"],
            ["6", "4", "5", "3", "2", "5", "5", "5"],
            ["5", "5", "6", "7", "6", "6", "5", "4"],
            ["6", "4", "5", "3", "2", "5", "3", "3"],
        ],
        amen: ["34", "323"],
        clef: "f5",
        tone: "2",
    },
    "almighty-god-who-from-the-flood": {
        // Thursday evening, ordinary time
        title: "Magnae Deus potentiae",
        text: [
            [
                ["AL", "MIGH", "TY"],
                ["God,"],
                ["who"],
                ["from"],
                ["the"],
                ["flood"],
            ],
            [
                ["Didst"],
                ["bring"],
                ["to"],
                ["light"],
                ["a"],
                ["two", "fold"],
                ["brood;"],
            ],
            [
                ["Part"],
                ["in"],
                ["the"],
                ["fir", "ma", "ment"],
                ["to"],
                ["fly,"],
            ],
            [
                ["And"],
                ["part"],
                ["in"],
                ["o", "cean’s"],
                ["depths"],
                ["to"],
                ["lie;"],
            ],
            [["Ap", "point", "ing"], ["fish", "es"], ["in"], ["the"], ["sea,"]],
            [
                ["And"],
                ["fowls"],
                ["in"],
                ["o", "pen"],
                ["air"],
                ["to"],
                ["be,"],
            ],
            [
                ["That"],
                ["each,"],
                ["by"],
                ["o", "ri", "gin"],
                ["the"],
                ["same,"],
            ],
            [
                ["Its"],
                ["sep", "arate"],
                ["dwell", "ing"],
                ["place"],
                ["might"],
                ["claim:"],
            ],
            [
                ["Grant"],
                ["that"],
                ["Thy"],
                ["ser", "vants,"],
                ["by"],
                ["the"],
                ["tide"],
            ],
            [["Of"], ["blood"], ["and"], ["wa", "ter"], ["pu", "ri", "fied,"]],
            [
                ["No"],
                ["guil", "ty"],
                ["fall"],
                ["from"],
                ["Thee"],
                ["may"],
                ["know,"],
            ],
            [["Nor"], ["death"], ["e", "ter", "nal"], ["un", "der", "go."]],
            [
                ["Be"],
                ["none"],
                ["sub", "merged"],
                ["in"],
                ["sin’s"],
                ["dis", "tress,"],
            ],
            [
                ["None"],
                ["lift", "ed"],
                ["up"],
                ["in"],
                ["boast", "ful", "ness;"],
            ],
            [
                ["That"],
                ["con", "trite"],
                ["hearts"],
                ["be"],
                ["not"],
                ["dis", "mayed,"],
            ],
            [
                ["Nor"],
                ["naugh", "ty"],
                ["souls"],
                ["in"],
                ["ru", "in"],
                ["laid."],
            ],
            [
                ["O"],
                ["Fa", "ther,"],
                ["that"],
                ["we"],
                ["ask"],
                ["be"],
                ["done,"],
            ],
            [
                ["Through"],
                ["Je", "sus"],
                ["Christ,"],
                ["thine"],
                ["on", "ly"],
                ["Son;"],
            ],
            [
                ["Who,"],
                ["with"],
                ["the"],
                ["Ho", "ly"],
                ["Ghost"],
                ["and"],
                ["thee,"],
            ],
            [
                ["Doth"],
                ["live"],
                ["and"],
                ["reign"],
                ["et", "er", "nal", "ly."],
            ],
        ],
        tune: [
            ["5", "5", "6", "7", "6", "6", "5", "4"],
            ["6", "4", "5", "3", "2", "5", "5", "5"],
            ["5", "5", "6", "7", "6", "6", "5", "4"],
            ["6", "4", "5", "3", "2", "5", "3", "3"],
        ],
        amen: ["34", "323"],
        clef: "f5",
        tone: "2",
    },
    "maker-of-man-who-from-thy-throne": {
        // Friday evening, ordinary time
        title: "Plasmator hominis, Deus",
        text: [
            [
                ["MA", "KER"],
                ["of"],
                ["man,"],
                ["who"],
                ["from"],
                ["Thy"],
                ["throne"],
            ],
            [
                ["Dost"],
                ["or", "der"],
                ["all"],
                ["things,"],
                ["God"],
                ["a", "lone;"],
            ],
            [
                ["By"],
                ["whose"],
                ["de", "cree"],
                ["the"],
                ["teem", "ing"],
                ["earth"],
            ],
            [
                ["To"],
                ["rep", "tile"],
                ["and"],
                ["to"],
                ["beast"],
                ["gave"],
                ["birth:"],
            ],
            [
                ["The"],
                ["migh", "ty"],
                ["forms"],
                ["that"],
                ["fill"],
                ["the"],
                ["land,"],
            ],
            [
                ["In", "stinct"],
                ["with"],
                ["life"],
                ["at"],
                ["Thy"],
                ["com", "mand,"],
            ],
            [
                ["Are"],
                ["giv’n"],
                ["sub", "dued"],
                ["to"],
                ["hu", "man", "kind"],
            ],
            [
                ["For"],
                ["ser", "vice"],
                ["in"],
                ["their"],
                ["rank"],
                ["a", "ssigned."],
            ],
            [
                ["From"],
                ["all"],
                ["Thy"],
                ["ser", "vants"],
                ["drive"],
                ["a", "way"],
            ],
            [
                ["What", "e’er"],
                ["of"],
                ["thought"],
                ["im", "pure"],
                ["to", "day"],
            ],
            [
                ["Hath"],
                ["been"],
                ["with"],
                ["o", "pen"],
                ["ac", "tion"],
                ["blent"],
            ],
            [
                ["Or"],
                ["min", "gled"],
                ["with"],
                ["the"],
                ["heart’s"],
                ["in", "tent."],
            ],
            [
                ["In"],
                ["Heav’n"],
                ["Thine"],
                ["end", "less"],
                ["joys"],
                ["be", "stow,"],
            ],
            [
                ["And"],
                ["grant"],
                ["Thy"],
                ["gifts"],
                ["of"],
                ["grace"],
                ["be", "low;"],
            ],
            [
                ["From"],
                ["chains"],
                ["of"],
                ["strife"],
                ["our"],
                ["souls"],
                ["re", "lease,"],
            ],
            [
                ["Bind"],
                ["fast"],
                ["the"],
                ["gen", "tle"],
                ["hands"],
                ["of"],
                ["peace."],
            ],
            [
                ["O"],
                ["Fa", "ther,"],
                ["that"],
                ["we"],
                ["ask"],
                ["be"],
                ["done,"],
            ],
            [
                ["Through"],
                ["Je", "sus"],
                ["Christ,"],
                ["thine"],
                ["on", "ly"],
                ["Son;"],
            ],
            [
                ["Who,"],
                ["with"],
                ["the"],
                ["Ho", "ly"],
                ["Ghost"],
                ["and"],
                ["thee,"],
            ],
            [
                ["Doth"],
                ["live"],
                ["and"],
                ["reign"],
                ["et", "er", "nal", "ly."],
            ],
        ],
        tune: [
            ["5", "5", "6", "7", "6", "6", "5", "4"],
            ["6", "4", "5", "3", "2", "5", "5", "5"],
            ["5", "5", "6", "7", "6", "6", "5", "4"],
            ["6", "4", "5", "3", "2", "5", "3", "3"],
        ],
        amen: ["34", "323"],
        clef: "f5",
        tone: "2",
    },
    "creator-of-the-earth-and-sky": {
        // Saturday evening, ordinary time
        title: "Deus Creator omnium",
        text: [
            [
                ["CRE", "A", "TOR"],
                ["of"],
                ["the"],
                ["earth"],
                ["and"],
                ["sky,"],
            ],
            [["Rul", "ing"], ["the"], ["fir", "ma", "ment"], ["on"], ["high,"]],
            [
                ["Cloth", "ing"],
                ["the"],
                ["day"],
                ["with"],
                ["robes"],
                ["of"],
                ["light,"],
            ],
            [
                ["Bless", "ing"],
                ["with"],
                ["gra", "cious"],
                ["sleep"],
                ["the"],
                ["night,"],
            ],
            [
                ["That"],
                ["rest"],
                ["may"],
                ["com", "fort"],
                ["wea", "ry"],
                ["men,"],
            ],
            [
                ["And"],
                ["brace"],
                ["to"],
                ["use", "ful"],
                ["toil"],
                ["a", "gain,"],
            ],
            [
                ["And"],
                ["soothe"],
                ["a", "while"],
                ["the"],
                ["ha", "rassed"],
                ["mind,"],
            ],
            [
                ["And"],
                ["sor", "row’s"],
                ["hea", "vy"],
                ["load"],
                ["un", "bind:"],
            ],
            [
                ["Day"],
                ["sinks;"],
                ["we"],
                ["thank"],
                ["thee"],
                ["for"],
                ["thy"],
                ["gift;"],
            ],
            [
                ["Night"],
                ["comes;"],
                ["and"],
                ["once"],
                ["a", "gain"],
                ["we"],
                ["lift"],
            ],
            [
                ["Our"],
                ["prayer"],
                ["and"],
                ["vows"],
                ["and"],
                ["hymns"],
                ["that"],
                ["we"],
            ],
            [
                ["A", "gainst"],
                ["all"],
                ["ills"],
                ["may"],
                ["shield", "ed"],
                ["be."],
            ],
            [
                ["That"],
                ["when"],
                ["black"],
                ["dark", "ness"],
                ["clo", "ses"],
                ["day,"],
            ],
            [
                ["And"],
                ["shad", "ows"],
                ["thick", "en"],
                ["round"],
                ["our"],
                ["way,"],
            ],
            [
                ["Faith"],
                ["may"],
                ["no"],
                ["dark", "ness"],
                ["know,"],
                ["and"],
                ["night"],
            ],
            [
                ["From"],
                ["faith’s"],
                ["clear"],
                ["beam"],
                ["may"],
                ["bor", "row"],
                ["light."],
            ],
            [
                ["Pray"],
                ["we"],
                ["the"],
                ["Fa", "ther"],
                ["and"],
                ["the"],
                ["Son,"],
            ],
            [
                ["And"],
                ["Ho", "ly"],
                ["Spi", "rit,"],
                ["Three"],
                ["in"],
                ["One;"],
            ],
            [["Blest"], ["Tri", "ni", "ty,"], ["whom"], ["all"], ["o", "bey,"]],
            [
                ["Guard"],
                ["thou"],
                ["thy"],
                ["sheep"],
                ["by"],
                ["night"],
                ["and"],
                ["day."],
            ],
        ],
        tune: [
            ["3", "2", "4", "54", "3", "45", "432", "2"],
            ["1", "15", "5", "5", "54", "57", "54", "45"],
            ["5", "5", "4", "54", "3", "4", "32", "1"],
            ["3", "2", "4", "54", "3", "45", "432", "2"],
        ],
        amen: ["23", "212"],
        clef: "c7",
        tone: "4",
    },
    "o-blest-creator-of-the-light": {
        // Sunday evening, ordinary time
        title: "Lucis Creator optime",
        text: [
            [
                ["O"],
                ["BLEST"],
                ["Cre", "a", "tor"],
                ["of"],
                ["the"],
                ["light,"],
            ],
            [
                ["Who"],
                ["mak’st"],
                ["the"],
                ["day"],
                ["with"],
                ["ra", "diance"],
                ["bright,"],
            ],
            [
                ["And"],
                ["o’er"],
                ["the"],
                ["form", "ing"],
                ["world"],
                ["didst"],
                ["call"],
            ],
            [
                ["The"],
                ["light"],
                ["from"],
                ["cha", "os"],
                ["first"],
                ["of"],
                ["all."],
            ],
            [
                ["Whose"],
                ["wis", "dom"],
                ["joined"],
                ["in"],
                ["meet"],
                ["arr", "ay"],
            ],
            [
                ["The"],
                ["morn"],
                ["and"],
                ["eve,"],
                ["and"],
                ["named"],
                ["them"],
                ["day:"],
            ],
            [
                ["Night"],
                ["comes"],
                ["with"],
                ["all"],
                ["its"],
                ["dark", "ling"],
                ["fears;"],
            ],
            [
                ["Re", "gard"],
                ["Thy"],
                ["peo", "ple’s"],
                ["prayers"],
                ["and"],
                ["tears."],
            ],
            [
                ["Lest,"],
                ["sunk"],
                ["in"],
                ["sin,"],
                ["and"],
                ["whelmed"],
                ["with"],
                ["strife,"],
            ],
            [
                ["They"],
                ["lose"],
                ["the"],
                ["gift"],
                ["of"],
                ["end", "less"],
                ["life;"],
            ],
            [
                ["While"],
                ["think", "ing"],
                ["but"],
                ["the"],
                ["thoughts"],
                ["of"],
                ["time,"],
            ],
            [
                ["They"],
                ["weave"],
                ["new"],
                ["chains"],
                ["of"],
                ["woe"],
                ["and"],
                ["crime."],
            ],
            [
                ["But"],
                ["grant"],
                ["them"],
                ["grace"],
                ["that"],
                ["they"],
                ["may"],
                ["strain"],
            ],
            [
                ["The"],
                ["heav'n", "ly"],
                ["gate"],
                ["and"],
                ["prize"],
                ["to"],
                ["gain:"],
            ],
            [
                ["Each"],
                ["harm", "ful"],
                ["lure"],
                ["a", "side"],
                ["to"],
                ["cast,"],
            ],
            [
                ["And"],
                ["purge"],
                ["a", "way"],
                ["each"],
                ["err", "or"],
                ["past."],
            ],
            [
                ["O"],
                ["Fa", "ther,"],
                ["that"],
                ["we"],
                ["ask"],
                ["be"],
                ["done,"],
            ],
            [
                ["Through"],
                ["Je", "sus"],
                ["Christ,"],
                ["thine"],
                ["on", "ly"],
                ["Son;"],
            ],
            [
                ["Who,"],
                ["with"],
                ["the"],
                ["Ho", "ly"],
                ["Ghost"],
                ["and"],
                ["thee,"],
            ],
            [
                ["Doth"],
                ["live"],
                ["and"],
                ["reign"],
                ["et", "er", "nal", "ly."],
            ],
        ],
        tune: [
            ["454", "3", "57", "7", "4", "54", "34", "4"],
            ["48", "898", "7", "76", "5", "76", "54", "454"],
            ["1", "132", "34", "45", "43", "4", "45", "5"],
            ["7", "787", "5", "65", "4", "54", "34", "4"],
        ],
        amen: ["45", "434"],
        clef: "c7",
        tone: "8",
    },
    "ye-choirs-of-new-jerusalem": {
        title: "Chorus novae Jerusalem",
        text: [
            [["Ye"], ["Choirs"], ["of"], ["New"], ["Je", "ru", "sa", "lem!"]],
            [
                ["To"],
                ["sweet"],
                ["new"],
                ["strains"],
                ["at", "tune"],
                ["your"],
                ["theme;"],
            ],
            [
                ["The"],
                ["while"],
                ["we"],
                ["keep,"],
                ["from"],
                ["care"],
                ["re", "leas'd,"],
            ],
            [
                ["With"],
                ["so", "ber"],
                ["joy"],
                ["our"],
                ["Pas", "chal"],
                ["Feast:"],
            ],
            [
                ["When"],
                ["Christ,"],
                ["Who"],
                ["spake"],
                ["the"],
                ["Dra", "gon's"],
                ["doom,"],
            ],
            [
                ["Rose,"],
                ["Vic", "tor-", "Li", "on,"],
                ["from"],
                ["the"],
                ["Tomb:"],
            ],
            [
                ["That"],
                ["while"],
                ["with"],
                ["liv", "ing"],
                ["voice"],
                ["He"],
                ["cries,"],
            ],
            [
                ["The"],
                ["dead"],
                ["of"],
                ["o", "ther"],
                ["years"],
                ["might"],
                ["rise."],
            ],
            [
                ["En", "gorg'd"],
                ["in"],
                ["for", "mer"],
                ["years,"],
                ["their"],
                ["prey"],
            ],
            [
                ["Must"],
                ["Death"],
                ["and"],
                ["Hell"],
                ["re", "store"],
                ["to", "day:"],
            ],
            [
                ["And"],
                ["ma", "ny-a"],
                ["cap", "tive"],
                ["soul,"],
                ["set"],
                ["free,"],
            ],
            [["With"], ["Je", "sus"], ["leaves"], ["cap", "ti", "vi", "ty."]],
            [
                ["Right"],
                ["glo", "rious", "ly"],
                ["He"],
                ["tri", "umphs"],
                ["now,"],
            ],
            [
                ["Wor", "thy"],
                ["to"],
                ["Whom"],
                ["should"],
                ["all"],
                ["things"],
                ["bow;"],
            ],
            [
                ["And,"],
                ["join", "ing"],
                ["heav'n"],
                ["and"],
                ["earth"],
                ["a", "gain,"],
            ],
            [
                ["Links"],
                ["in"],
                ["one"],
                ["com", "mon", "weal"],
                ["the"],
                ["twain."],
            ],
            [
                ["And"],
                ["we,"],
                ["as"],
                ["these"],
                ["His"],
                ["deeds"],
                ["we"],
                ["sing,"],
            ],
            [
                ["His"],
                ["sup", "pliant"],
                ["sol", "diers,"],
                ["pray"],
                ["our"],
                ["King,"],
            ],
            [
                ["That"],
                ["in"],
                ["His"],
                ["Pa", "lace,"],
                ["bright"],
                ["and"],
                ["vast,"],
            ],
            [
                ["We"],
                ["may"],
                ["keep"],
                ["watch"],
                ["and"],
                ["ward"],
                ["at"],
                ["last."],
            ],
            [["Long"], ["as"], ["un", "end", "ing"], ["a", "ges"], ["run,"]],
            [
                ["To"],
                ["God"],
                ["the"],
                ["Fa", "ther"],
                ["laud"],
                ["be"],
                ["done;"],
            ],
            [
                ["To"],
                ["God"],
                ["the"],
                ["Son"],
                ["our"],
                ["e", "qual"],
                ["praise,"],
            ],
            [
                ["And"],
                ["God"],
                ["the"],
                ["Ho", "ly"],
                ["Ghost,"],
                ["we"],
                ["raise."],
            ],
        ],

        tune: [
            ["234", "32", "12", "2", "10", "1", "31", "232"],
            ["210", "4", "5", "6", "7", "654", "7", "654"],
            ["65", "4", "54", "321", "234", "3", "2", "1"],
            ["5", "4", "5", "654", "5", "431234", "32", "2"],
        ],
        amen: ["23", "212"],
        clef: "c7",
        tone: "3",
    },
    "the-day-draws-on-ferias": {
        title: "Aurora lucis rutilat",
        text: [
            [
                ["THE"],
                ["day"],
                ["draws"],
                ["on"],
                ["with"],
                ["gol", "den"],
                ["light,"],
            ],
            [
                ["Glad"],
                ["songs"],
                ["go"],
                ["ech", "oing"],
                ["through"],
                ["the"],
                ["height,"],
            ],
            [
                ["The"],
                ["broad"],
                ["earth"],
                ["lifts"],
                ["an"],
                ["ans", "wering"],
                ["cheer,"],
            ],
            [
                ["And"],
                ["hell"],
                ["makes"],
                ["moan"],
                ["with"],
                ["wail", "ing"],
                ["fear."],
            ],
            [
                ["For"],
                ["lo,"],
                ["he"],
                ["comes,"],
                ["the"],
                ["migh", "ty"],
                ["King,"],
            ],
            [
                ["To"],
                ["take"],
                ["from"],
                ["death"],
                ["his"],
                ["power"],
                ["and"],
                ["sting,"],
            ],
            [
                ["To"],
                ["tram", "ple"],
                ["down"],
                ["his"],
                ["gloo", "my"],
                ["reign,"],
            ],
            [
                ["And"],
                ["break"],
                ["the"],
                ["wea", "ry"],
                ["pris", "'ner’s"],
                ["chain."],
            ],
            [
                ["En", "closed"],
                ["he"],
                ["lay"],
                ["in"],
                ["roc", "ky"],
                ["cell,"],
            ],
            [["With"], ["guard"], ["of"], ["arm", "èd"], ["sen", "ti", "nel;"]],
            [
                ["But"],
                ["thence"],
                ["re", "turn", "ing,"],
                ["strong"],
                ["and"],
                ["free,"],
            ],
            [
                ["He"],
                ["comes"],
                ["in"],
                ["might"],
                ["of"],
                ["vic", "to", "ry."],
            ],
            [
                ["Ma", "ker"],
                ["of"],
                ["all,"],
                ["to"],
                ["thee"],
                ["we"],
                ["pray,"],
            ],
            [["Ful", "fil"], ["in"], ["us"], ["thy"], ["joy"], ["to", "day;"]],
            [
                ["When"],
                ["death"],
                ["ass", "ails,"],
                ["grant,"],
                ["Lord,"],
                ["that"],
                ["we"],
            ],
            [
                ["May"],
                ["share"],
                ["thy"],
                ["Pas", "chal"],
                ["vic", "to", "ry."],
            ],
            [
                ["To"],
                ["thee"],
                ["who,"],
                ["dead,"],
                ["a", "gain"],
                ["dost"],
                ["live,"],
            ],
            [
                ["All"],
                ["glo", "ry,"],
                ["Lord,"],
                ["thy"],
                ["peo", "ple"],
                ["give,"],
            ],
            [["All"], ["glo", "ry"], ["to"], ["the"], ["Fa", "ther"], ["be"]],
            [["And"], ["Spi", "rit"], ["blest,"], ["e", "ter", "nal", "ly."]],
        ],
        tune: [
            ["4", "4", "5", "6", "7", "6", "5", "4"],
            ["7", "7", "7", "6", "4", "5", "7", "7876"],
            ["5", "6", "7", "8", "6", "7", "6", "5"],
            ["5", "6", "7", "6", "5", "6", "5", "4"],
        ],
        amen: ["45", "434"],
        clef: "c7",
        tone: "8",
    },
    "the-day-draws-on-apostles": {
        title: "Aurora lucis rutilat (Apostles)",
        text: [
            [
                ["THE"],
                ["day"],
                ["draws"],
                ["on"],
                ["with"],
                ["gol", "den"],
                ["light,"],
            ],
            [
                ["Glad"],
                ["songs"],
                ["go"],
                ["ech", "oing"],
                ["through"],
                ["the"],
                ["height,"],
            ],
            [
                ["The"],
                ["broad"],
                ["earth"],
                ["lifts"],
                ["an"],
                ["ans", "wering"],
                ["cheer,"],
            ],
            [
                ["And"],
                ["hell"],
                ["makes"],
                ["moan"],
                ["with"],
                ["wail", "ing"],
                ["fear."],
            ],
            [
                ["For"],
                ["lo,"],
                ["he"],
                ["comes,"],
                ["the"],
                ["migh", "ty"],
                ["King,"],
            ],
            [
                ["To"],
                ["take"],
                ["from"],
                ["death"],
                ["his"],
                ["power"],
                ["and"],
                ["sting,"],
            ],
            [
                ["To"],
                ["tram", "ple"],
                ["down"],
                ["his"],
                ["gloo", "my"],
                ["reign,"],
            ],
            [
                ["And"],
                ["break"],
                ["the"],
                ["wea", "ry"],
                ["pris", "'ner’s"],
                ["chain."],
            ],
            [
                ["En", "closed"],
                ["he"],
                ["lay"],
                ["in"],
                ["roc", "ky"],
                ["cell,"],
            ],
            [["With"], ["guard"], ["of"], ["arm", "èd"], ["sen", "ti", "nel;"]],
            [
                ["But"],
                ["thence"],
                ["re", "turn", "ing,"],
                ["strong"],
                ["and"],
                ["free,"],
            ],
            [
                ["He"],
                ["comes"],
                ["in"],
                ["might"],
                ["of"],
                ["vic", "to", "ry."],
            ],
            [
                ["The"],
                ["sad"],
                ["A", "po", "stles"],
                ["mourn"],
                ["him"],
                ["slain,"],
            ],
            [
                ["Nor"],
                ["hope"],
                ["to"],
                ["see"],
                ["their"],
                ["Lord"],
                ["a", "gain,"],
            ],
            [
                ["When,"],
                ["to"],
                ["their"],
                ["ve", "ry"],
                ["eyes"],
                ["re", "stored,"],
            ],
            [
                ["They"],
                ["look"],
                ["up", "on"],
                ["the"],
                ["ri", "sen"],
                ["Lord."],
            ],
            [
                ["But"],
                ["now"],
                ["they"],
                ["put"],
                ["their"],
                ["grief"],
                ["a", "way,"],
            ],
            [
                ["The"],
                ["pains"],
                ["of"],
                ["hell"],
                ["are"],
                ["loosed"],
                ["to", "day;"],
            ],
            [
                ["For"],
                ["by"],
                ["the"],
                ["grave,"],
                ["with"],
                ["flash", "ing"],
                ["eyes,"],
            ],
            [
                ['"Your'],
                ["Lord"],
                ["is"],
                ["ris'n\""],
                ["the"],
                ["An", "gel"],
                ["cries."],
            ],
            [
                ["Ma", "ker"],
                ["of"],
                ["all,"],
                ["to"],
                ["thee"],
                ["we"],
                ["pray,"],
            ],
            [["Ful", "fil"], ["in"], ["us"], ["thy"], ["joy"], ["to", "day;"]],
            [
                ["When"],
                ["death"],
                ["ass", "ails,"],
                ["grant,"],
                ["Lord,"],
                ["that"],
                ["we"],
            ],
            [
                ["May"],
                ["share"],
                ["thy"],
                ["Pas", "chal"],
                ["vic", "to", "ry."],
            ],
            [
                ["To"],
                ["thee"],
                ["who,"],
                ["dead,"],
                ["a", "gain"],
                ["dost"],
                ["live,"],
            ],
            [
                ["All"],
                ["glo", "ry,"],
                ["Lord,"],
                ["thy"],
                ["peo", "ple"],
                ["give,"],
            ],
            [["All"], ["glo", "ry"], ["to"], ["the"], ["Fa", "ther"], ["be"]],
            [["And"], ["Spi", "rit"], ["blest,"], ["e", "ter", "nal", "ly."]],
        ],
        tune: [
            ["4", "4", "5", "6", "7", "6", "5", "4"],
            ["7", "7", "7", "6", "4", "5", "7", "7876"],
            ["5", "6", "7", "8", "6", "7", "6", "5"],
            ["5", "6", "7", "6", "5", "6", "5", "4"],
        ],
        amen: ["45", "434"],
        clef: "c7",
        tone: "8",
    },
    "eternal-monarch-king-most-high": {
        title: "Aeterne Rex altissime",
        text: [
            [
                ["E", "ter", "nal"],
                ["Mon", "arch,"],
                ["King"],
                ["most"],
                ["high,"],
            ],
            [
                ["Whose"],
                ["blood"],
                ["hath"],
                ["brought"],
                ["re", "demp", "tion"],
                ["nigh,"],
            ],
            [
                ["By"],
                ["whom"],
                ["the"],
                ["death"],
                ["of"],
                ["Death"],
                ["was"],
                ["wrought"],
            ],
            [
                ["And"],
                ["con", "quering"],
                ["gra", "ce’s"],
                ["bat", "tle"],
                ["fought:"],
            ],
            [
                ["A", "scend", "ing"],
                ["to"],
                ["the"],
                ["throne"],
                ["of"],
                ["might,"],
            ],
            [
                ["And"],
                ["seat", "ed"],
                ["at"],
                ["the"],
                ["Fa", "ther’s"],
                ["right,"],
            ],
            [
                ["All"],
                ["power"],
                ["in"],
                ["heaven"],
                ["is"],
                ["Jes", "u’s"],
                ["own,"],
            ],
            [
                ["That"],
                ["here"],
                ["his"],
                ["man", "hood"],
                ["had"],
                ["not"],
                ["known."],
            ],
            [
                ["Yea,"],
                ["an", "gels"],
                ["trem", "ble"],
                ["when"],
                ["they"],
                ["see"],
            ],
            [["How"], ["changed"], ["is"], ["our"], ["hu", "ma", "ni", "ty;"]],
            [
                ["That"],
                ["flesh"],
                ["hath"],
                ["purged"],
                ["what"],
                ["flesh"],
                ["had"],
                ["stained,"],
            ],
            [
                ["And"],
                ["God,"],
                ["the"],
                ["flesh"],
                ["of"],
                ["God,"],
                ["hath"],
                ["reigned."],
            ],
            [
                ["Be"],
                ["thou"],
                ["our"],
                ["joy"],
                ["and"],
                ["strong"],
                ["de", "fence,"],
            ],
            [
                ["Who"],
                ["art"],
                ["our"],
                ["fu", "ture"],
                ["re", "com", "pense:"],
            ],
            [
                ["So"],
                ["shall"],
                ["the"],
                ["light"],
                ["that"],
                ["springs"],
                ["from"],
                ["thee"],
            ],
            [["Be"], ["ours"], ["through"], ["all"], ["e", "ter", "ni", "ty."]],
            [
                ["O"],
                ["ris", "en"],
                ["Christ,"],
                ["a", "scen", "ded"],
                ["Lord,"],
            ],
            [
                ["All"],
                ["praise"],
                ["to"],
                ["thee"],
                ["let"],
                ["earth"],
                ["ac", "cord,"],
            ],
            [
                ["Who"],
                ["art,"],
                ["while"],
                ["end", "less"],
                ["ag", "es"],
                ["run,"],
            ],
            [
                ["With"],
                ["Fa", "ther"],
                ["and"],
                ["with"],
                ["Spi", "rit"],
                ["One."],
            ],
        ],
        tune: [
            ["4", "45675", "43", "54", "567654", "54", "34", "4"],
            ["4", "476", "78", "8", "76", "54", "57", "7"],
            ["7", "5", "7", "4", "45", "54", "34", "4"],
            ["3", "54", "57", "76", "54", "54", "34", "4"],
        ],
        amen: ["45", "434"],
        clef: "c7",
        tone: "8",
    },
    "when-christ-our-lord-had-passed-once-more": {
        title: "Jam Christus astra ascenderat",
        text: [
            [
                ["When"],
                ["Christ"],
                ["our"],
                ["Lord"],
                ["had"],
                ["passed"],
                ["once"],
                ["more"],
            ],
            [
                ["In", "to"],
                ["the"],
                ["heaven"],
                ["He"],
                ["left"],
                ["be", "fore,"],
            ],
            [["He"], ["sent"], ["a"], ["Com", "for", "ter"], ["below"]],
            [
                ["The"],
                ["Fa", "ther’s"],
                ["pro", "mise"],
                ["to"],
                ["be", "stow."],
            ],
            [
                ["The"],
                ["so", "lemn"],
                ["time"],
                ["was"],
                ["soon"],
                ["to"],
                ["fall"],
            ],
            [
                ["Which"],
                ["told"],
                ["the"],
                ["num", "ber"],
                ["my", "sti", "cal"],
            ],
            [
                ["For"],
                ["since"],
                ["the"],
                ["re", "sur", "rec", "tion"],
                ["day"],
            ],
            [
                ["A"],
                ["week"],
                ["of"],
                ["weeks"],
                ["had"],
                ["passed"],
                ["a", "way."],
            ],
            [
                ["At"],
                ["the"],
                ["third"],
                ["hour"],
                ["a"],
                ["rush", "ing"],
                ["noise"],
            ],
            [
                ["Came"],
                ["like"],
                ["the"],
                ["tem", "pest’s"],
                ["sud", "den"],
                ["voice,"],
            ],
            [
                ["And"],
                ["min", "gled"],
                ["with"],
                ["the-a", "pos", "tles’"],
                ["prayer,"],
            ],
            [
                ["Pro", "claim", "ing"],
                ["loud"],
                ["that"],
                ["God"],
                ["was"],
                ["there."],
            ],
            [
                ["From"],
                ["out"],
                ["the"],
                ["Fa", "ther’s"],
                ["light"],
                ["it"],
                ["came,"],
            ],
            [
                ["That"],
                ["beau", "ti", "ful"],
                ["and"],
                ["kind", "ly"],
                ["flame,"],
            ],
            [
                ["To"],
                ["kin", "dle"],
                ["eve", "ry"],
                ["Christ", "ian"],
                ["heart,"],
            ],
            [
                ["And"],
                ["fer", "vor"],
                ["of"],
                ["the"],
                ["Word"],
                ["im", "part."],
            ],
            [
                ["As"],
                ["then,"],
                ["O"],
                ["Lord,"],
                ["Thou"],
                ["didst"],
                ["ful", "fill,"],
            ],
            [
                ["Each"],
                ["ho", "ly"],
                ["heart"],
                ["to"],
                ["do"],
                ["Thy"],
                ["will,"],
            ],
            [
                ["So"],
                ["now"],
                ["do"],
                ["Thou"],
                ["our"],
                ["sins"],
                ["for", "give"],
            ],
            [
                ["And"],
                ["make"],
                ["the"],
                ["world"],
                ["in"],
                ["peace"],
                ["to"],
                ["live."],
            ],
            [
                ["To"],
                ["God"],
                ["the"],
                ["Fa", "ther,"],
                ["God"],
                ["the"],
                ["Son,"],
            ],
            [
                ["And"],
                ["God"],
                ["the"],
                ["Spi", "rit,"],
                ["praise"],
                ["be"],
                ["done;"],
            ],
            [
                ["May"],
                ["Christ"],
                ["the"],
                ["Lord"],
                ["up", "on"],
                ["us"],
                ["pour"],
            ],
            [["The"], ["Spi", "rit’s"], ["gift"], ["for", "ev", "er", "more."]],
        ],
        tune: [
            ["1", "1", "3", "1", "10", "3", "4", "5"],
            ["54", "7", "78", "7", "76", "5", "4", "5"],
            ["5", "5", "5765", "43", "21", "3", "21", "12"],
            ["0", "21", "4", "454", "32", "1", "0", "1"],
        ],
        amen: ["12", "101"],
        clef: "c7",
        tone: "1",
    },
    "rejoice-the-year-upon-its-way": {
        title: "Beata nobis gaudia",
        text: [
            [
                ["Re", "joice!"],
                ["the"],
                ["year"],
                ["up", "on"],
                ["its"],
                ["way"],
            ],
            [
                ["Has"],
                ["brought"],
                ["a", "gain"],
                ["that"],
                ["bless", "èd"],
                ["day,"],
            ],
            [
                ["When"],
                ["on"],
                ["the"],
                ["cho", "sen"],
                ["of"],
                ["the"],
                ["Lord"],
            ],
            [
                ["The"],
                ["Ho", "ly"],
                ["Spi", "rit"],
                ["was"],
                ["out", "poured."],
            ],
            [
                ["On"],
                ["each"],
                ["the"],
                ["fire,"],
                ["de", "scend", "ing,"],
                ["stood"],
            ],
            [
                ["In"],
                ["qui", "v'ring"],
                ["tongues’"],
                ["si", "mi", "li", "tude,"],
            ],
            [
                ["Tongues,"],
                ["that"],
                ["their"],
                ["words"],
                ["might"],
                ["rea", "dy"],
                ["prove,"],
            ],
            [
                ["And"],
                ["fire,"],
                ["to"],
                ["make"],
                ["them"],
                ["flame"],
                ["with"],
                ["love."],
            ],
            [
                ["To"],
                ["all"],
                ["in"],
                ["eve", "ry"],
                ["tongue"],
                ["they"],
                ["spoke;"],
            ],
            [["A", "maze", "ment"], ["in"], ["the"], ["crowd"], ["a", "woke,"]],
            [
                ["Who"],
                ["mocked,"],
                ["as"],
                ["o", "ver", "come"],
                ["with"],
                ["wine,"],
            ],
            [
                ["Those"],
                ["who"],
                ["were"],
                ["filled"],
                ["with"],
                ["power"],
                ["di", "vine."],
            ],
            [
                ["These"],
                ["things"],
                ["were"],
                ["done"],
                ["in"],
                ["type"],
                ["that"],
                ["day,"],
            ],
            [
                ["When"],
                ["Eas", "ter", "tide"],
                ["had"],
                ["passed"],
                ["a", "way,"],
            ],
            [
                ["The"],
                ["num", "ber"],
                ["told"],
                ["which"],
                ["once"],
                ["set"],
                ["free"],
            ],
            [["The"], ["cap", "tive"], ["at"], ["the"], ["ju", "bi", "lee."]],
            [
                ["And"],
                ["now,"],
                ["O"],
                ["ho", "ly"],
                ["God,"],
                ["this"],
                ["day"],
            ],
            [["Re", "gard"], ["us"], ["as"], ["we"], ["humb", "ly"], ["pray,"]],
            [
                ["And"],
                ["send"],
                ["us,"],
                ["from"],
                ["Thy"],
                ["heav'n", "ly"],
                ["seat,"],
            ],
            [
                ["The"],
                ["bless", "ings"],
                ["of"],
                ["the"],
                ["Pa", "ra", "clete."],
            ],
            [
                ["To"],
                ["God"],
                ["the"],
                ["Fa", "ther,"],
                ["God"],
                ["the"],
                ["Son,"],
            ],
            [
                ["And"],
                ["God"],
                ["the"],
                ["Spi", "rit,"],
                ["praise"],
                ["be"],
                ["done;"],
            ],
            [
                ["May"],
                ["Christ"],
                ["the"],
                ["Lord"],
                ["up", "on"],
                ["us"],
                ["pour"],
            ],
            [["The"], ["Spi", "rit’s"], ["gift"], ["for", "ev", "er", "more."]],
        ],
        tune: [
            ["23", "378b", "7", "7", "76", "67", "6", "65"],
            ["7", "7", "6", "54", "3", "45", "32", "23"],
            ["0", "23", "3", "35", "53", "4", "3", "2"],
            ["6", "6", "5", "676", "43", "45", "32", "23"],
        ],
        amen: ["34", "323"],
        clef: "f5",
        tone: "8",
    },
    "creator-of-the-stars-of-night": {
        title: "Conditor alme siderum",
        text: [
            [
                ["Cre", "a", "tor"],
                ["of"],
                ["the"],
                ["stars"],
                ["of"],
                ["night,"],
            ],
            [
                ["Thy"],
                ["peo", "ple’s"],
                ["ev", "er", "last", "ing"],
                ["light,"],
            ],
            [["Je", "su,"], ["Re", "dee", "mer,"], ["save"], ["us"], ["all,"]],
            [
                ["And"],
                ["hear"],
                ["thy"],
                ["ser", "vants"],
                ["when"],
                ["they"],
                ["call."],
            ],
            [
                ["Thou,"],
                ["griev", "ing"],
                ["that"],
                ["the"],
                ["an", "cient"],
                ["curse"],
            ],
            [
                ["Should"],
                ["doom"],
                ["to"],
                ["death"],
                ["a"],
                ["u", "ni", "verse,"],
            ],
            [
                ["Hast"],
                ["found"],
                ["the"],
                ["med'", "cine,"],
                ["full"],
                ["of"],
                ["grace,"],
            ],
            [
                ["To"],
                ["save"],
                ["and"],
                ["heal"],
                ["a"],
                ["ru", "ined"],
                ["race."],
            ],
            [
                ["Thou"],
                ["cam’st,"],
                ["the"],
                ["Bride", "groom"],
                ["of"],
                ["the"],
                ["bride,"],
            ],
            [
                ["As"],
                ["drew"],
                ["the"],
                ["world"],
                ["to"],
                ["eve", "ning-", "tide;"],
            ],
            [
                ["Pro", "ceed", "ing"],
                ["from"],
                ["a"],
                ["vir", "gin"],
                ["shrine,"],
            ],
            [
                ["The"],
                ["spot", "less"],
                ["vic", "tim"],
                ["all"],
                ["di", "vine."],
            ],
            [
                ["At"],
                ["whose"],
                ["dread"],
                ["name,"],
                ["ma", "jes", "tic"],
                ["now,"],
            ],
            [
                ["All"],
                ["knees"],
                ["must"],
                ["bend,"],
                ["all"],
                ["hearts"],
                ["must"],
                ["bow;"],
            ],
            [
                ["And"],
                ["things"],
                ["ce", "les", "tial"],
                ["Thee"],
                ["shall"],
                ["own,"],
            ],
            [
                ["And"],
                ["things"],
                ["ter", "res", "trial,"],
                ["Lord"],
                ["a", "lone."],
            ],
            [
                ["O"],
                ["Thou"],
                ["whose"],
                ["com", "ing"],
                ["is"],
                ["with"],
                ["dread"],
            ],
            [
                ["To"],
                ["judge"],
                ["and"],
                ["doom"],
                ["the"],
                ["quick"],
                ["and"],
                ["dead,"],
            ],
            [
                ["Pre", "serve"],
                ["us,"],
                ["while"],
                ["we"],
                ["dwell"],
                ["be", "low,"],
            ],
            [
                ["From"],
                ["ev", "'ry"],
                ["in", "sult"],
                ["of"],
                ["the"],
                ["foe."],
            ],
            [
                ["To"],
                ["God"],
                ["the"],
                ["Fa", "ther,"],
                ["God"],
                ["the"],
                ["Son,"],
            ],
            [
                ["And"],
                ["God"],
                ["the"],
                ["Spi", "rit,"],
                ["Three"],
                ["in"],
                ["One,"],
            ],
            [
                ["Laud,"],
                ["ho", "nor,"],
                ["might,"],
                ["and"],
                ["glo", "ry"],
                ["be"],
            ],
            [["From"], ["age"], ["to"], ["age"], ["e", "ter", "nal", "ly."]],
        ],
        tune: [
            ["4", "2", "4", "6", "7", "7", "5", "6"],
            ["6", "7", "5", "6", "5", "4", "3", "4"],
            ["6", "5", "3", "4", "5", "4", "3", "2"],
            ["2", "4", "5", "6", "5", "4", "3", "4"],
        ],
        amen: ["45", "434"],
        clef: "f5",
        tone: "4",
    },
    "to-earth-descending-word-sublime": {
        title: "Verbum supernum prodiens",
        text: [
            [
                ["To"],
                ["earth"],
                ["de", "scend", "ing,"],
                ["Word"],
                ["sub", "lime,"],
            ],
            [
                ["Be", "got", "ten"],
                ["ere"],
                ["the"],
                ["days"],
                ["of"],
                ["time,"],
            ],
            [
                ["Who"],
                ["cam’st"],
                ["a"],
                ["Child,"],
                ["the"],
                ["world"],
                ["to"],
                ["aid,"],
            ],
            [
                ["As"],
                ["years"],
                ["their"],
                ["down", "ward"],
                ["course"],
                ["dis", "play’d:"],
            ],
            [
                ["Each"],
                ["breast"],
                ["be"],
                ["light", "en’d"],
                ["from"],
                ["a", "bove,"],
            ],
            [
                ["Each"],
                ["heart"],
                ["be"],
                ["kin", "dled"],
                ["with"],
                ["Thy"],
                ["love;"],
            ],
            [
                ["That"],
                ["we,"],
                ["who"],
                ["hear"],
                ["Thy"],
                ["call"],
                ["to-", "day,"],
            ],
            [
                ["At"],
                ["length"],
                ["may"],
                ["cast"],
                ["earth’s"],
                ["joys"],
                ["a", "way."],
            ],
            [
                ["That"],
                ["so,"],
                ["when"],
                ["Thou,"],
                ["our"],
                ["Judge,"],
                ["art"],
                ["nigh,"],
            ],
            [
                ["All"],
                ["sec", "ret"],
                ["deeds"],
                ["of"],
                ["men"],
                ["to"],
                ["try,"],
            ],
            [
                ["Shalt"],
                ["mete"],
                ["to"],
                ["sin"],
                ["pangs"],
                ["right", "ly"],
                ["won,"],
            ],
            [
                ["To"],
                ["just"],
                ["men"],
                ["joy"],
                ["for"],
                ["deeds"],
                ["well"],
                ["done,"],
            ],
            [
                ["Thy"],
                ["ser", "vants"],
                ["may"],
                ["not"],
                ["be"],
                ["en", "chain’d"],
            ],
            [
                ["By"],
                ["pu", "nish", "ment"],
                ["their"],
                ["guilt"],
                ["has"],
                ["gain’d:"],
            ],
            [["But"], ["with"], ["the"], ["bless", "ed"], ["e", "ver", "more"]],
            [
                ["May"],
                ["serve"],
                ["and"],
                ["love"],
                ["Thee,"],
                ["and"],
                ["a", "dore."],
            ],
            [
                ["To"],
                ["Him"],
                ["Who"],
                ["comes"],
                ["the"],
                ["world"],
                ["to"],
                ["free,"],
            ],
            [
                ["To"],
                ["God"],
                ["the"],
                ["Son,"],
                ["all"],
                ["glo", "ry"],
                ["be:"],
            ],
            [
                ["To"],
                ["God"],
                ["the"],
                ["Fa", "ther,"],
                ["as"],
                ["is"],
                ["meet,"],
            ],
            [["To"], ["God"], ["the"], ["Bless", "ed"], ["Pa", "ra", "clete."]],
        ],
        tune: [
            ["2", "0", "2", "4", "5", "6", "5", "5"],
            ["4", "5", "7", "7", "64", "5", "6", "5"],
            ["5", "5", "6", "4", "24", "3", "2", "1"],
            ["2", "0", "2", "4", "5", "6", "5", "5"],
        ],
        amen: ["56", "545"],
        clef: "c7",
        tone: "2",
    },
    "jesu-the-fathers-only-son": {
        title: "Christe Redemptor omnium",
        text: [
            [["Je", "su,"], ["the"], ["Fa", "ther’s"], ["on", "ly"], ["Son,"]],
            [
                ["Whose"],
                ["death"],
                ["for"],
                ["all"],
                ["re", "demp", "tion"],
                ["won;"],
            ],
            [
                ["Be", "fore"],
                ["the"],
                ["worlds"],
                ["of"],
                ["God"],
                ["most"],
                ["high"],
            ],
            [["Be", "got", "ten"], ["all"], ["in", "eff", "ab", "ly."]],
            [
                ["The"],
                ["Fa", "ther’s"],
                ["light"],
                ["and"],
                ["splen", "dor"],
                ["Thou,"],
            ],
            [
                ["Their"],
                ["end", "less"],
                ["hope"],
                ["to"],
                ["Thee"],
                ["that"],
                ["bow;"],
            ],
            [
                ["Ac", "cept"],
                ["the"],
                ["pray'rs"],
                ["and"],
                ["praise"],
                ["to", "day"],
            ],
            [
                ["That"],
                ["through"],
                ["the"],
                ["world"],
                ["Thy"],
                ["ser", "vants"],
                ["pray."],
            ],
            [
                ["Sal", "va", "tion’s"],
                ["au", "thor,"],
                ["call"],
                ["to"],
                ["mind"],
            ],
            [
                ["How,"],
                ["tak", "ing"],
                ["form"],
                ["of"],
                ["hu", "man", "kind,"],
            ],
            [["Born"], ["of"], ["a"], ["vir", "gin"], ["un", "de", "filed,"]],
            [
                ["Thou"],
                ["in"],
                ["man’s"],
                ["flesh"],
                ["be", "cam’st"],
                ["a"],
                ["child."],
            ],
            [
                ["Thus"],
                ["tes", "ti", "fies"],
                ["the"],
                ["pre", "sent"],
                ["day,"],
            ],
            [
                ["Through"],
                ["ev'", "ry"],
                ["year"],
                ["in"],
                ["long"],
                ["arr", "ay,"],
            ],
            [
                ["That"],
                ["Thou,"],
                ["sal", "va", "tion’s"],
                ["source"],
                ["a", "lone,"],
            ],
            [
                ["Pro", "ceed", "est"],
                ["from"],
                ["the"],
                ["Fa", "ther’s"],
                ["throne."],
            ],
            [
                ["Whence"],
                ["sky,"],
                ["and"],
                ["stars,"],
                ["and"],
                ["sea’s"],
                ["a", "byss,"],
            ],
            [
                ["And"],
                ["earth,"],
                ["and"],
                ["all"],
                ["that"],
                ["there", "in"],
                ["is,"],
            ],
            [
                ["Shall"],
                ["still,"],
                ["with"],
                ["laud"],
                ["and"],
                ["ca", "rol"],
                ["meet,"],
            ],
            [
                ["The"],
                ["Au", "thor"],
                ["of"],
                ["Thine"],
                ["ad", "vent"],
                ["greet."],
            ],
            [
                ["And"],
                ["we"],
                ["who,"],
                ["by"],
                ["Thy"],
                ["pre", "cious"],
                ["blood"],
            ],
            [
                ["From"],
                ["sin"],
                ["re", "deemed,"],
                ["are"],
                ["marked"],
                ["for"],
                ["God,"],
            ],
            [
                ["On"],
                ["this"],
                ["the"],
                ["day"],
                ["that"],
                ["saw"],
                ["Thy"],
                ["birth,"],
            ],
            [
                ["Sing"],
                ["the"],
                ["new"],
                ["song"],
                ["of"],
                ["ran", "somed"],
                ["earth."],
            ],
            [
                ["For"],
                ["that"],
                ["Thine"],
                ["ad", "vent"],
                ["glo", "ry"],
                ["be,"],
            ],
            [
                ["O"],
                ["Je", "su,"],
                ["vir", "gin"],
                ["born,"],
                ["to"],
                ["Thee;"],
            ],
            [
                ["With"],
                ["Fa", "ther,"],
                ["and"],
                ["with"],
                ["Ho", "ly"],
                ["Ghost,"],
            ],
            [
                ["From"],
                ["men"],
                ["and"],
                ["from"],
                ["the"],
                ["heav'n", "ly"],
                ["host."],
            ],
        ],
        tune: [
            ["0", "1", "24", "43", "21", "3", "210", "1"],
            ["02", "4", "45", "5", "54", "47", "654", "5"],
            ["57", "4", "43", "2", "10", "1", "12", "2"],
            ["0", "1", "24", "43", "21", "3", "210", "1"],
        ],
        amen: ["12", "101"],
        clef: "c7",
        tone: "1",
    },
    "from-east-to-west-from-shore-to-shore": {
        title: "A solis ortus cardine",
        text: [
            [
                ["From"],
                ["east"],
                ["to"],
                ["west,"],
                ["from"],
                ["shore"],
                ["to"],
                ["shore"],
            ],
            [
                ["Let"],
                ["ev'", "ry"],
                ["heart"],
                ["a", "wake"],
                ["and"],
                ["sing"],
            ],
            [
                ["The"],
                ["ho", "ly"],
                ["child"],
                ["whom"],
                ["Ma", "ry"],
                ["bore,"],
            ],
            [
                ["The"],
                ["Christ,"],
                ["the"],
                ["ev", "er", "last", "ing"],
                ["king."],
            ],
            [
                ["Be", "hold,"],
                ["the"],
                ["world's"],
                ["cre", "a", "tor"],
                ["wears"],
            ],
            [
                ["The"],
                ["form"],
                ["and"],
                ["fa", "shion"],
                ["of"],
                ["a"],
                ["slave;"],
            ],
            [
                ["Our"],
                ["ve", "ry"],
                ["flesh"],
                ["our"],
                ["ma", "ker"],
                ["shares,"],
            ],
            [
                ["His"],
                ["fall", "en"],
                ["crea", "tures"],
                ["all"],
                ["to"],
                ["save."],
            ],
            [
                ["For"],
                ["this"],
                ["how"],
                ["won", "drous", "ly"],
                ["He"],
                ["wrought!"],
            ],
            [
                ["A"],
                ["mai", "den,"],
                ["in"],
                ["her"],
                ["low", "ly"],
                ["place,"],
            ],
            [
                ["Be", "came,"],
                ["in"],
                ["ways"],
                ["bey", "ond"],
                ["all"],
                ["thought,"],
            ],
            [
                ["The"],
                ["cho", "sen"],
                ["ves", "sel"],
                ["of"],
                ["His"],
                ["grace."],
            ],
            [
                ["And"],
                ["while"],
                ["the"],
                ["an", "gels"],
                ["in"],
                ["the"],
                ["sky"],
            ],
            [
                ["Sang"],
                ["praise"],
                ["a", "bove"],
                ["the"],
                ["si", "lent"],
                ["field,"],
            ],
            [
                ["To"],
                ["shep", "herds"],
                ["poor"],
                ["the"],
                ["Lord"],
                ["Most"],
                ["High,"],
            ],
            [
                ["the"],
                ["one"],
                ["great"],
                ["Shep", "herd,"],
                ["was"],
                ["re", "vealed."],
            ],
            [
                ["All"],
                ["glo", "ry"],
                ["for"],
                ["this"],
                ["bless", "ed"],
                ["morn"],
            ],
            [["To"], ["God"], ["the"], ["Fa", "ther"], ["ev", "er"], ["be;"]],
            [
                ["All"],
                ["praise"],
                ["to"],
                ["You,"],
                ["O"],
                ["Vir", "gin", "born,"],
            ],
            [["And"], ["Ho", "ly"], ["Ghost"], ["e", "ter", "nal", "ly."]],
        ],
        tune: [
            ["1", "2", "3", "45", "1", "234", "32", "2"],
            ["4", "57", "7", "76", "54", "56", "6", "6"],
            ["5", "578", "7", "76", "54", "5765", "43", "2345"],
            ["1", "2", "3", "5", "5765", "4234", "32", "2"],
        ],
        amen: ["23", "212"],
        clef: "c7",
        tone: "3",
    },
};
